var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js"(exports, module) {
    "use strict";
    function arrayMap(array, iteratee) {
      var index = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    module.exports = arrayMap;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"(exports, module) {
    "use strict";
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKey.js
var require_isKey = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKey.js"(exports, module) {
    "use strict";
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    var reIsPlainProp = /^\w*$/;
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    module.exports = isKey;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObject = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js"(exports, module) {
    "use strict";
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module.exports = coreJsData;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js"(exports, module) {
    "use strict";
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js"(exports, module) {
    "use strict";
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module.exports = toSource;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js"(exports, module) {
    "use strict";
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    module.exports = getValue;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"(exports, module) {
    "use strict";
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    module.exports = getNative;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module.exports = nativeCreate;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module.exports = hashClear;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js"(exports, module) {
    "use strict";
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = hashDelete;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    module.exports = hashGet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    module.exports = hashHas;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module.exports = hashSet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js"(exports, module) {
    "use strict";
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module.exports = Hash;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js"(exports, module) {
    "use strict";
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module.exports = listCacheClear;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js
var require_eq = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js"(exports, module) {
    "use strict";
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module.exports = eq;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js"(exports, module) {
    "use strict";
    var eq = require_eq();
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module.exports = assocIndexOf;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module.exports = listCacheDelete;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    module.exports = listCacheGet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module.exports = listCacheHas;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module.exports = listCacheSet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js"(exports, module) {
    "use strict";
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module.exports = ListCache;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Map = getNative(root, "Map");
    module.exports = Map;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js"(exports, module) {
    "use strict";
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map || ListCache)(),
        "string": new Hash()
      };
    }
    module.exports = mapCacheClear;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js"(exports, module) {
    "use strict";
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module.exports = isKeyable;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js"(exports, module) {
    "use strict";
    var isKeyable = require_isKeyable();
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    module.exports = getMapData;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = mapCacheDelete;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module.exports = mapCacheGet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module.exports = mapCacheHas;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module.exports = mapCacheSet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js"(exports, module) {
    "use strict";
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module.exports = MapCache;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js
var require_memoize = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js"(exports, module) {
    "use strict";
    var MapCache = require_MapCache();
    var FUNC_ERROR_TEXT = "Expected a function";
    function memoize(func, resolver) {
      if (typeof func != "function" || resolver != null && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache)();
      return memoized;
    }
    memoize.Cache = MapCache;
    module.exports = memoize;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_memoizeCapped.js
var require_memoizeCapped = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_memoizeCapped.js"(exports, module) {
    "use strict";
    var memoize = require_memoize();
    var MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });
      var cache = result.cache;
      return result;
    }
    module.exports = memoizeCapped;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToPath.js
var require_stringToPath = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToPath.js"(exports, module) {
    "use strict";
    var memoizeCapped = require_memoizeCapped();
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46) {
        result.push("");
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
      });
      return result;
    });
    module.exports = stringToPath;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var arrayMap = require_arrayMap();
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isArray(value)) {
        return arrayMap(value, baseToString) + "";
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module.exports = baseToString;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js
var require_toString = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js"(exports, module) {
    "use strict";
    var baseToString = require_baseToString();
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    module.exports = toString;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castPath.js
var require_castPath = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castPath.js"(exports, module) {
    "use strict";
    var isArray = require_isArray();
    var isKey = require_isKey();
    var stringToPath = require_stringToPath();
    var toString = require_toString();
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }
    module.exports = castPath;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toKey.js
var require_toKey = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toKey.js"(exports, module) {
    "use strict";
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    function toKey(value) {
      if (typeof value == "string" || isSymbol(value)) {
        return value;
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module.exports = toKey;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGet.js
var require_baseGet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGet.js"(exports, module) {
    "use strict";
    var castPath = require_castPath();
    var toKey = require_toKey();
    function baseGet(object, path) {
      path = castPath(path, object);
      var index = 0, length = path.length;
      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return index && index == length ? object : void 0;
    }
    module.exports = baseGet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js
var require_stackClear = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module.exports = stackClear;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js
var require_stackDelete = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js"(exports, module) {
    "use strict";
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    module.exports = stackDelete;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js
var require_stackGet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js"(exports, module) {
    "use strict";
    function stackGet(key) {
      return this.__data__.get(key);
    }
    module.exports = stackGet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js
var require_stackHas = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js"(exports, module) {
    "use strict";
    function stackHas(key) {
      return this.__data__.has(key);
    }
    module.exports = stackHas;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js
var require_stackSet = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var Map = require_Map();
    var MapCache = require_MapCache();
    var LARGE_ARRAY_SIZE = 200;
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    module.exports = stackSet;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js
var require_Stack = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var stackClear = require_stackClear();
    var stackDelete = require_stackDelete();
    var stackGet = require_stackGet();
    var stackHas = require_stackHas();
    var stackSet = require_stackSet();
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module.exports = Stack;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js
var require_setCacheAdd = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js"(exports, module) {
    "use strict";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    module.exports = setCacheAdd;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js
var require_setCacheHas = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js"(exports, module) {
    "use strict";
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    module.exports = setCacheHas;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js
var require_SetCache = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js"(exports, module) {
    "use strict";
    var MapCache = require_MapCache();
    var setCacheAdd = require_setCacheAdd();
    var setCacheHas = require_setCacheHas();
    function SetCache(values) {
      var index = -1, length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    module.exports = SetCache;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js
var require_arraySome = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js"(exports, module) {
    "use strict";
    function arraySome(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    module.exports = arraySome;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js
var require_cacheHas = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js"(exports, module) {
    "use strict";
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    module.exports = cacheHas;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js
var require_equalArrays = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js"(exports, module) {
    "use strict";
    var SetCache = require_SetCache();
    var arraySome = require_arraySome();
    var cacheHas = require_cacheHas();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index < arrLength) {
        var arrValue = array[index], othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    module.exports = equalArrays;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js
var require_Uint8Array = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Uint8Array2 = root.Uint8Array;
    module.exports = Uint8Array2;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js
var require_mapToArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js"(exports, module) {
    "use strict";
    function mapToArray(map) {
      var index = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    module.exports = mapToArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js
var require_setToArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js"(exports, module) {
    "use strict";
    function setToArray(set) {
      var index = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index] = value;
      });
      return result;
    }
    module.exports = setToArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js
var require_equalByTag = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var Uint8Array2 = require_Uint8Array();
    var eq = require_eq();
    var equalArrays = require_equalArrays();
    var mapToArray = require_mapToArray();
    var setToArray = require_setToArray();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    module.exports = equalByTag;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js
var require_arrayPush = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js"(exports, module) {
    "use strict";
    function arrayPush(array, values) {
      var index = -1, length = values.length, offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    module.exports = arrayPush;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js
var require_baseGetAllKeys = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js"(exports, module) {
    "use strict";
    var arrayPush = require_arrayPush();
    var isArray = require_isArray();
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    module.exports = baseGetAllKeys;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js
var require_arrayFilter = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js"(exports, module) {
    "use strict";
    function arrayFilter(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    module.exports = arrayFilter;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js
var require_stubArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js"(exports, module) {
    "use strict";
    function stubArray() {
      return [];
    }
    module.exports = stubArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js
var require_getSymbols = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js"(exports, module) {
    "use strict";
    var arrayFilter = require_arrayFilter();
    var stubArray = require_stubArray();
    var objectProto = Object.prototype;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    module.exports = getSymbols;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js
var require_baseTimes = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js"(exports, module) {
    "use strict";
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    module.exports = baseTimes;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js"(exports, module) {
    "use strict";
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module.exports = isArguments;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js
var require_stubFalse = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js"(exports, module) {
    "use strict";
    function stubFalse() {
      return false;
    }
    module.exports = stubFalse;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js
var require_isBuffer = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js"(exports, module) {
    "use strict";
    var root = require_root();
    var stubFalse = require_stubFalse();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    module.exports = isIndex;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js
var require_baseIsTypedArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isLength = require_isLength();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    module.exports = baseIsTypedArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js"(exports, module) {
    "use strict";
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module.exports = baseUnary;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js
var require_nodeUtil = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    module.exports = nodeUtil;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js
var require_isTypedArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js"(exports, module) {
    "use strict";
    var baseIsTypedArray = require_baseIsTypedArray();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module.exports = isTypedArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js
var require_arrayLikeKeys = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js"(exports, module) {
    "use strict";
    var baseTimes = require_baseTimes();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isIndex = require_isIndex();
    var isTypedArray = require_isTypedArray();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = arrayLikeKeys;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js
var require_isPrototype = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    module.exports = isPrototype;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js
var require_overArg = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js"(exports, module) {
    "use strict";
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    module.exports = overArg;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js
var require_nativeKeys = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js"(exports, module) {
    "use strict";
    var overArg = require_overArg();
    var nativeKeys = overArg(Object.keys, Object);
    module.exports = nativeKeys;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js
var require_baseKeys = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js"(exports, module) {
    "use strict";
    var isPrototype = require_isPrototype();
    var nativeKeys = require_nativeKeys();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeys;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module.exports = isArrayLike;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js
var require_keys = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js"(exports, module) {
    "use strict";
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeys = require_baseKeys();
    var isArrayLike = require_isArrayLike();
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    module.exports = keys;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js
var require_getAllKeys = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js"(exports, module) {
    "use strict";
    var baseGetAllKeys = require_baseGetAllKeys();
    var getSymbols = require_getSymbols();
    var keys = require_keys();
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    module.exports = getAllKeys;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js
var require_equalObjects = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js"(exports, module) {
    "use strict";
    var getAllKeys = require_getAllKeys();
    var COMPARE_PARTIAL_FLAG = 1;
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    module.exports = equalObjects;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js
var require_DataView = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var DataView = getNative(root, "DataView");
    module.exports = DataView;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js
var require_Promise = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Promise2 = getNative(root, "Promise");
    module.exports = Promise2;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js
var require_Set = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Set = getNative(root, "Set");
    module.exports = Set;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js
var require_WeakMap = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var WeakMap = getNative(root, "WeakMap");
    module.exports = WeakMap;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js
var require_getTag = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js"(exports, module) {
    "use strict";
    var DataView = require_DataView();
    var Map = require_Map();
    var Promise2 = require_Promise();
    var Set = require_Set();
    var WeakMap = require_WeakMap();
    var baseGetTag = require_baseGetTag();
    var toSource = require_toSource();
    var mapTag = "[object Map]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var setTag = "[object Set]";
    var weakMapTag = "[object WeakMap]";
    var dataViewTag = "[object DataView]";
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set);
    var weakMapCtorString = toSource(WeakMap);
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function(value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    module.exports = getTag;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js
var require_baseIsEqualDeep = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js"(exports, module) {
    "use strict";
    var Stack = require_Stack();
    var equalArrays = require_equalArrays();
    var equalByTag = require_equalByTag();
    var equalObjects = require_equalObjects();
    var getTag = require_getTag();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isTypedArray = require_isTypedArray();
    var COMPARE_PARTIAL_FLAG = 1;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var objectTag = "[object Object]";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    module.exports = baseIsEqualDeep;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js
var require_baseIsEqual = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js"(exports, module) {
    "use strict";
    var baseIsEqualDeep = require_baseIsEqualDeep();
    var isObjectLike = require_isObjectLike();
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    module.exports = baseIsEqual;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMatch.js
var require_baseIsMatch = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMatch.js"(exports, module) {
    "use strict";
    var Stack = require_Stack();
    var baseIsEqual = require_baseIsEqual();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length, length = index, noCustomizer = !customizer;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
          if (objValue === void 0 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack();
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }
    module.exports = baseIsMatch;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isStrictComparable.js
var require_isStrictComparable = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isStrictComparable.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }
    module.exports = isStrictComparable;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMatchData.js
var require_getMatchData = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMatchData.js"(exports, module) {
    "use strict";
    var isStrictComparable = require_isStrictComparable();
    var keys = require_keys();
    function getMatchData(object) {
      var result = keys(object), length = result.length;
      while (length--) {
        var key = result[length], value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }
    module.exports = getMatchData;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_matchesStrictComparable.js
var require_matchesStrictComparable = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_matchesStrictComparable.js"(exports, module) {
    "use strict";
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
      };
    }
    module.exports = matchesStrictComparable;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatches.js
var require_baseMatches = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatches.js"(exports, module) {
    "use strict";
    var baseIsMatch = require_baseIsMatch();
    var getMatchData = require_getMatchData();
    var matchesStrictComparable = require_matchesStrictComparable();
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }
    module.exports = baseMatches;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js
var require_get = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js"(exports, module) {
    "use strict";
    var baseGet = require_baseGet();
    function get(object, path, defaultValue) {
      var result = object == null ? void 0 : baseGet(object, path);
      return result === void 0 ? defaultValue : result;
    }
    module.exports = get;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHasIn.js
var require_baseHasIn = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHasIn.js"(exports, module) {
    "use strict";
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }
    module.exports = baseHasIn;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasPath.js
var require_hasPath = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasPath.js"(exports, module) {
    "use strict";
    var castPath = require_castPath();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isIndex = require_isIndex();
    var isLength = require_isLength();
    var toKey = require_toKey();
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);
      var index = -1, length = path.length, result = false;
      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
    }
    module.exports = hasPath;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/hasIn.js
var require_hasIn = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/hasIn.js"(exports, module) {
    "use strict";
    var baseHasIn = require_baseHasIn();
    var hasPath = require_hasPath();
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }
    module.exports = hasIn;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatchesProperty.js
var require_baseMatchesProperty = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatchesProperty.js"(exports, module) {
    "use strict";
    var baseIsEqual = require_baseIsEqual();
    var get = require_get();
    var hasIn = require_hasIn();
    var isKey = require_isKey();
    var isStrictComparable = require_isStrictComparable();
    var matchesStrictComparable = require_matchesStrictComparable();
    var toKey = require_toKey();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }
    module.exports = baseMatchesProperty;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/identity.js
var require_identity = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/identity.js"(exports, module) {
    "use strict";
    function identity(value) {
      return value;
    }
    module.exports = identity;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js
var require_baseProperty = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js"(exports, module) {
    "use strict";
    function baseProperty(key) {
      return function(object) {
        return object == null ? void 0 : object[key];
      };
    }
    module.exports = baseProperty;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePropertyDeep.js
var require_basePropertyDeep = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePropertyDeep.js"(exports, module) {
    "use strict";
    var baseGet = require_baseGet();
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }
    module.exports = basePropertyDeep;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/property.js
var require_property = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/property.js"(exports, module) {
    "use strict";
    var baseProperty = require_baseProperty();
    var basePropertyDeep = require_basePropertyDeep();
    var isKey = require_isKey();
    var toKey = require_toKey();
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }
    module.exports = property;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIteratee.js
var require_baseIteratee = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIteratee.js"(exports, module) {
    "use strict";
    var baseMatches = require_baseMatches();
    var baseMatchesProperty = require_baseMatchesProperty();
    var identity = require_identity();
    var isArray = require_isArray();
    var property = require_property();
    function baseIteratee(value) {
      if (typeof value == "function") {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == "object") {
        return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
      }
      return property(value);
    }
    module.exports = baseIteratee;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseFor.js
var require_createBaseFor = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseFor.js"(exports, module) {
    "use strict";
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    module.exports = createBaseFor;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFor.js
var require_baseFor = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFor.js"(exports, module) {
    "use strict";
    var createBaseFor = require_createBaseFor();
    var baseFor = createBaseFor();
    module.exports = baseFor;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseForOwn.js
var require_baseForOwn = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseForOwn.js"(exports, module) {
    "use strict";
    var baseFor = require_baseFor();
    var keys = require_keys();
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }
    module.exports = baseForOwn;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseEach.js
var require_createBaseEach = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseEach.js"(exports, module) {
    "use strict";
    var isArrayLike = require_isArrayLike();
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while (fromRight ? index-- : ++index < length) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }
    module.exports = createBaseEach;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEach.js
var require_baseEach = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEach.js"(exports, module) {
    "use strict";
    var baseForOwn = require_baseForOwn();
    var createBaseEach = require_createBaseEach();
    var baseEach = createBaseEach(baseForOwn);
    module.exports = baseEach;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMap.js
var require_baseMap = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMap.js"(exports, module) {
    "use strict";
    var baseEach = require_baseEach();
    var isArrayLike = require_isArrayLike();
    function baseMap(collection, iteratee) {
      var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
      baseEach(collection, function(value, key, collection2) {
        result[++index] = iteratee(value, key, collection2);
      });
      return result;
    }
    module.exports = baseMap;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSortBy.js
var require_baseSortBy = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSortBy.js"(exports, module) {
    "use strict";
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    module.exports = baseSortBy;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareAscending.js
var require_compareAscending = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareAscending.js"(exports, module) {
    "use strict";
    var isSymbol = require_isSymbol();
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
          return 1;
        }
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }
    module.exports = compareAscending;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareMultiple.js
var require_compareMultiple = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_compareMultiple.js"(exports, module) {
    "use strict";
    var compareAscending = require_compareAscending();
    function compareMultiple(object, other, orders) {
      var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == "desc" ? -1 : 1);
        }
      }
      return object.index - other.index;
    }
    module.exports = compareMultiple;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseOrderBy.js
var require_baseOrderBy = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseOrderBy.js"(exports, module) {
    "use strict";
    var arrayMap = require_arrayMap();
    var baseGet = require_baseGet();
    var baseIteratee = require_baseIteratee();
    var baseMap = require_baseMap();
    var baseSortBy = require_baseSortBy();
    var baseUnary = require_baseUnary();
    var compareMultiple = require_compareMultiple();
    var identity = require_identity();
    var isArray = require_isArray();
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }
      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
      var result = baseMap(collection, function(value, key, collection2) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { "criteria": criteria, "index": ++index, "value": value };
      });
      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }
    module.exports = baseOrderBy;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/orderBy.js
var require_orderBy = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/orderBy.js"(exports, module) {
    "use strict";
    var baseOrderBy = require_baseOrderBy();
    var isArray = require_isArray();
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? void 0 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }
    module.exports = orderBy;
  }
});

// src/common/Button.tsx
import clsx from "clsx";
import React from "react";
import { LoadingIcon } from "@alphafounders/icons";
function Button({
  onClick,
  id,
  text,
  icon,
  stopPropagating = false,
  variant = "primary",
  className = "",
  disabled = false,
  dataTestId,
  isLoading = false,
  loadingText = "",
  type = "button",
  rounded = false,
  roundedNone = false,
  iconType = "svg"
}) {
  const handleClick = (e) => {
    if (stopPropagating) {
      e.preventDefault();
      e.stopPropagation();
    }
    onClick?.(e);
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      id,
      type,
      className: clsx(
        "font-bold uppercase flex items-center justify-center border-solid cursor-pointer",
        {
          "bg-primary text-white border-none disabled:bg-disabledColor disabled:cursor-default": variant === "primary",
          "bg-white border-1 text-primary border-primary disabled:text-muted-dark disabled:border-muted-dark disabled:cursor-default": variant === "secondary",
          "font-normal": variant === "custom",
          "rounded-lg": !rounded && !roundedNone,
          "rounded-full": rounded,
          "rounded-none": roundedNone
        },
        className
      ),
      onClick: handleClick,
      disabled: isLoading || disabled,
      "data-testid": dataTestId
    },
    isLoading ? /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex justify-center items-center",
        "data-testid": "loading-btn"
      },
      /* @__PURE__ */ React.createElement(LoadingIcon, null),
      ` ${loadingText}`
    ) : /* @__PURE__ */ React.createElement(React.Fragment, null, iconType === "svg" ? icon : /* @__PURE__ */ React.createElement("img", { src: icon?.toString(), className: "w-7" }), text)
  );
}
var Button_default = Button;

// src/common/Input.tsx
import clsx2 from "clsx";
import React2 from "react";
function Input({
  id,
  name,
  error,
  success,
  placeholder,
  label,
  adornment,
  className,
  dataTestId,
  disabled = false,
  value = "",
  onChange,
  onFocus,
  onBlur,
  onPaste
}) {
  return /* @__PURE__ */ React2.createElement("div", { className: clsx2(className, "flex justify-end flex-col w-full mx-2") }, /* @__PURE__ */ React2.createElement(
    "label",
    {
      htmlFor: id || name,
      className: clsx2(
        `text-[10px] text-slate-800 capitalize min-h-[11px] mb-1`,
        error && "!text-red-600",
        success && "!text-green-600"
      )
    },
    label
  ), /* @__PURE__ */ React2.createElement("div", { className: "flex flex-row justify-start h-[42px]" }, /* @__PURE__ */ React2.createElement(
    "input",
    {
      id: id || name,
      className: clsx2(
        `transition border-2 border-solid border-slate-200 hover:border-primary focus:border-primary focus:outline-none focus:ring-0 min-w-[150px] w-full p-0 px-2 h-[42px]`,
        success && "!border-green-600 !focus:border-green-600 !hover:border-green-600 !text-green-600 !placeholder:text-green-600",
        error && "!border-red-600 !focus:border-red-600 !hover:border-red-600 !text-red-600 !placeholder:text-red-600",
        disabled && "!border-stone-300 !focus:border-stone-300 !hover:border-stone-300 !placeholder:text-stone-300 !bg-stone-300",
        adornment && "!rounded-l rounded-none",
        !adornment && "rounded"
      ),
      "data-testid": dataTestId,
      ...{
        value,
        placeholder,
        disabled,
        onChange,
        onBlur,
        onFocus,
        onPaste
      }
    }
  ), adornment && /* @__PURE__ */ React2.createElement(
    "span",
    {
      "data-testid": "adornment-element",
      className: "flex items-center justify-center p-2 px-3 z-2 pointer-events-none rounded-none !rounded-r bg-gray-200"
    },
    adornment
  )), /* @__PURE__ */ React2.createElement(
    "span",
    {
      "data-testid": "validation-element",
      className: clsx2(
        "mt-1 text-[10px] min-h-[12px]",
        error && "text-red-600",
        success && "text-green-600"
      )
    },
    error || success
  ));
}
var Input_default = Input;

// src/common/Textarea.tsx
import clsx3 from "clsx";
import React3, { useEffect, useRef } from "react";
function TextArea({
  value,
  onChange,
  label,
  error,
  maxHeight = 100
}) {
  const textareaRef = useRef(null);
  const resizeTextArea = () => {
    textareaRef.current.style.height = "0px";
    textareaRef.current.style.height = `${Math.min(
      textareaRef.current?.scrollHeight ?? 0,
      maxHeight
    )}px`;
  };
  const handleChange = (e) => {
    onChange?.(e);
    resizeTextArea();
  };
  useEffect(() => {
    resizeTextArea();
  }, [value]);
  return /* @__PURE__ */ React3.createElement("div", { className: "w-full mx-auto mt-0 inline-flex flex-col" }, label && /* @__PURE__ */ React3.createElement("div", { className: "text-xs text-left" }, label), /* @__PURE__ */ React3.createElement(
    "textarea",
    {
      ref: textareaRef,
      className: clsx3("font-sans resize-none rounded-md p-1 hover:border", {
        "border-red-600": Boolean(error),
        "border-muted-light": !error
      }),
      rows: 1,
      value,
      onChange: handleChange
    }
  ), error && /* @__PURE__ */ React3.createElement("span", { className: "text-xs text-left text-red-600" }, error));
}
var Textarea_default = TextArea;

// src/common/Divider.tsx
import clsx4 from "clsx";
import React4 from "react";
var getPatternClass = (pattern) => {
  switch (pattern) {
    case "dash":
      return "border-dashed";
    case "solid":
      return "border-solid";
    default:
      return "";
  }
};
var getVariantClass = (variant) => {
  switch (variant) {
    case "primary":
      return "border-gray-400";
    case "secondary":
      return "border-muted-light";
    default:
      return "";
  }
};
function Divider({
  text,
  orientation = "horizontal",
  pattern = "solid",
  variant = "primary",
  className = ""
}) {
  const patternClass = getPatternClass(pattern);
  const variantClass = getVariantClass(variant);
  const dividerClassNames = `flex-grow border-b-0 border-t-[1px] ${patternClass} ${variantClass}`;
  return /* @__PURE__ */ React4.createElement(
    "div",
    {
      className: clsx4("relative flex py-3 items-center", className, {
        [`border-0 border-l-[1px] ${variantClass} ${patternClass}`]: orientation === "vertical"
      }),
      "data-testid": "careos-divider"
    },
    /* @__PURE__ */ React4.createElement("div", { className: dividerClassNames }),
    text && /* @__PURE__ */ React4.createElement("span", { className: "flex-shrink mx-4 text-gray-400" }, text),
    /* @__PURE__ */ React4.createElement("div", { className: dividerClassNames })
  );
}
var Divider_default = Divider;

// src/common/Card.tsx
import clsx5 from "clsx";
import React5 from "react";
var getVariantClass2 = (variant) => {
  switch (variant) {
    case "info":
      return "bg-success text-white";
    case "secondary":
      return "bg-secondary text-white";
    case "primary":
      return "bg-primary text-white";
    case "muted":
      return "bg-muted text-white";
    default:
      return "";
  }
};
function Card({
  title,
  headerProps,
  children,
  action,
  variant = "info",
  ...props
}) {
  return /* @__PURE__ */ React5.createElement(
    "section",
    {
      className: "bg-white my-4 rounded-lg hover:shadow-header hover:cursor-pointer",
      "data-testid": props["data-testid"]
    },
    title && /* @__PURE__ */ React5.createElement(
      "div",
      {
        className: clsx5(
          "rounded-t-lg p-3 text-white text-base font-bold flex justify-between",
          getVariantClass2(variant),
          headerProps?.className
        ),
        "data-testid": "card-title-header"
      },
      /* @__PURE__ */ React5.createElement("span", null, title),
      /* @__PURE__ */ React5.createElement("span", null, action)
    ),
    children
  );
}
var Card_default = Card;

// src/common/Header.tsx
import clsx6 from "clsx";
import React6 from "react";
function Header({
  icon,
  label,
  menuButton,
  phoneButton,
  contactButtons,
  customerPortalButton,
  localeButtons,
  shadow,
  dataTestId,
  fullWidth,
  noDivideIconAndLabel,
  labelColor,
  labelStyles,
  isLocalesShowOnMobile = false
}) {
  return /* @__PURE__ */ React6.createElement(
    "div",
    {
      className: clsx6("w-full flex justify-center", [shadow && "shadow-lg"]),
      "data-testid": dataTestId
    },
    /* @__PURE__ */ React6.createElement(
      "div",
      {
        className: clsx6(
          "flex justify-between items-center w-full lg:px-[2rem] xl:px-[3.75rem]",
          [!fullWidth && "max-w-[90rem]"]
        )
      },
      /* @__PURE__ */ React6.createElement("div", { className: "flex items-center" }, menuButton, /* @__PURE__ */ React6.createElement("div", { className: "flex flex-col md:flex-row justify-center items-end md:items-center" }, icon, label && /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(
        "div",
        {
          className: clsx6("border-r-0 mx-2  h-8 hidden md:block", [
            !noDivideIconAndLabel && "border-solid border-l-[0.5px] border-muted-light"
          ])
        }
      ), /* @__PURE__ */ React6.createElement(
        "span",
        {
          className: clsx6(
            "uppercase leading-tight text-[0.6875rem] md:text-sm",
            [labelColor ?? "text-primary"],
            labelStyles
          )
        },
        label
      )))),
      /* @__PURE__ */ React6.createElement("div", { className: "space-x-1 flex items-center" }, /* @__PURE__ */ React6.createElement("div", { className: "space-x-1 largerThan395:space-x-1.5 lg:space-x-2.5 flex items-center" }, phoneButton, contactButtons && /* @__PURE__ */ React6.createElement("div", { className: "space-x-1 flex items-center" }, contactButtons), customerPortalButton), localeButtons && Array.isArray(localeButtons) && localeButtons.length !== 0 && /* @__PURE__ */ React6.createElement(
        "div",
        {
          className: clsx6("space-x-1 items-center", {
            "hidden lg:flex": !isLocalesShowOnMobile,
            flex: isLocalesShowOnMobile
          })
        },
        /* @__PURE__ */ React6.createElement("div", { className: "mx-0.5 sm:mx-2 border-dashed border-l border-t-0 border-b-0 border-r-0 border-muted-light h-8" }),
        /* @__PURE__ */ React6.createElement("div", { className: "space-x-1 flex" }, localeButtons)
      ))
    )
  );
}
var Header_default = Header;

// src/common/ToggleSwitch.tsx
import clsx7 from "clsx";
import React7 from "react";
function ToggleSwitch({
  label,
  onClick,
  disabled = false,
  checked = false
}) {
  const handleClick = () => {
    if (disabled) return;
    onClick?.();
  };
  return /* @__PURE__ */ React7.createElement(
    "div",
    {
      className: "flex flex-row justify-center items-center ",
      "data-testid": "toggle-switch-btn"
    },
    label && /* @__PURE__ */ React7.createElement(
      "span",
      {
        "data-testid": "toggle-btn-label",
        className: "form-check-label leading-tight inline-block text-primary mr-1"
      },
      label
    ),
    /* @__PURE__ */ React7.createElement(
      "div",
      {
        className: clsx7(
          "w-10 h-5 flex items-center rounded-full p-1 cursor-pointer",
          checked ? "bg-primary" : "bg-muted-dark"
        ),
        onClick: handleClick,
        onKeyDown: handleClick,
        role: "button",
        tabIndex: 0
      },
      /* @__PURE__ */ React7.createElement(
        "div",
        {
          className: clsx7(
            "bg-white h-4 w-4 rounded-full shadow-md transform duration-300 ease-in-out",
            checked && "transform translate-x-4"
          )
        }
      )
    )
  );
}

// src/common/Buttons/AnchorButton.tsx
import clsx8 from "clsx";
import React8 from "react";
import { twMerge } from "tailwind-merge";
function AnchorButton({
  icon,
  dataTestId,
  className,
  children,
  ...rest
}) {
  return /* @__PURE__ */ React8.createElement(
    "a",
    {
      "data-testid": dataTestId,
      className: twMerge(
        clsx8(
          "flex max-h-[2.625rem] justify-center items-center no-underline rounded-full",
          "p-2 border border-solid space-x-2"
        ),
        className
      ),
      ...rest
    },
    icon,
    children
  );
}
var AnchorButton_default = AnchorButton;

// src/common/Buttons/DropdownButton.tsx
var import_orderBy = __toESM(require_orderBy());
import clsx9 from "clsx";
import React11, { useRef as useRef2, useState } from "react";

// src/Context/useUIContext.tsx
import { useContext } from "react";

// src/Context/index.tsx
import React9, {
  createContext,
  useEffect as useEffect2,
  useMemo
} from "react";

// src/translations/en.ts
var en_default = {
  appointment: "Appointment",
  leadAssigned: "Assigned Lead",
  orderQcFailed: "QC Issue",
  orderQcFixed: "QC Fixed",
  save: "Save",
  cancel: "Cancel",
  add: "Add",
  open: "Open",
  close: "Close",
  selectTheTime: "Please select the time",
  numberOfFreeSlot: "Free",
  numberOfPaymentCall: "Payment call",
  numberOfAppointment: "Appointment",
  THB: "THB",
  dragAndDropFile: "Drag and Drop file here or",
  chooseFile: "choose file",
  noData: "No Data",
  notification: {
    attached: "Attached",
    appointmentDate: "Starting at",
    discountRequestCreatedTitle: "Discount Request Submitted by",
    discountRequestCreatedDate: "Requested on",
    contractSignedDate: "Signed on",
    contractSignedTitle: "Contract Signed",
    customerName: "Customer Name",
    customerFullName: "Customer Fullname",
    documentAddedDate: "Attached on",
    discountRequestApprovedDate: "Approved on",
    discountRequestRejectedDate: "Rejected on",
    earliestPolicyStartDate: "Policy start date",
    mailDate: "Replied on",
    mailTitle: "Email replied",
    idCard: "ID Card",
    leadHumanID: "Lead ID",
    leadAssignmentDate: "Assigned on",
    leadAssignmentTitle: "New lead assigned",
    leadId: "Lead ID",
    mins: "mins",
    noNotification: "No Notification Today",
    older: "Older",
    orderId: "Order ID",
    orderQcFailedDate: "Reported on",
    orderQcFailedTitle: "QC issue",
    orderQcFixedDate: "Fixed on",
    orderQcFixedTitle: "QC Fixed",
    showMore: "Show More",
    showUnRead: "Show unread",
    title: "Notifications",
    today: "Today",
    with: "with",
    titles: {
      firstNamedDrivingLicense: "First Named Driver License",
      discountRequestApproved: "Discount request approved",
      discountRequestRejected: "Discount request rejected",
      idCard: "ID Card",
      otherDocument: "Other Document",
      paymentSlip: "Payment Slip",
      secondNamedDrivingLicense: "Second Named Driver License",
      vehicleDashcamPicture: "Dash Cam Picture",
      vehicleBackPicture: "Vehicle Back Picture ",
      vehicleFrontPicture: "Vehicle Front Picture",
      vehicleLeftPicture: "Vehicle Left Picture",
      vehicleRightPicture: "Vehicle Right Picture",
      vehicleRegistration: "Vehicle Registration"
    }
  },
  select: "Please select"
};

// src/translations/th.ts
var th_default = {
  appointment: "\u0E19\u0E31\u0E14\u0E2B\u0E21\u0E32\u0E22",
  leadAssigned: "\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E25\u0E35\u0E14",
  orderQcFailed: "\u0E1E\u0E1A\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E20\u0E32\u0E1E",
  orderQcFixed: "\u0E1B\u0E31\u0E0D\u0E2B\u0E32 QC \u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E49\u0E27",
  save: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
  cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
  add: "\u0E40\u0E1E\u0E34\u0E48\u0E21",
  open: "\u0E40\u0E1B\u0E34\u0E14",
  close: "\u0E1B\u0E34\u0E14",
  selectTheTime: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E27\u0E25\u0E32",
  numberOfFreeSlot: "\u0E17\u0E35\u0E48\u0E27\u0E48\u0E32\u0E07",
  numberOfPaymentCall: "\u0E19\u0E31\u0E14\u0E2B\u0E21\u0E32\u0E22\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
  numberOfAppointment: "\u0E19\u0E31\u0E14\u0E2B\u0E21\u0E32\u0E22\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
  THB: "\u0E1A\u0E32\u0E17",
  chooseFile: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E1F\u0E25\u0E4C",
  dragAndDropFile: "\u0E25\u0E32\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48 \u0E2B\u0E23\u0E37\u0E2D",
  noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
  notification: {
    attached: "\u0E16\u0E39\u0E01\u0E41\u0E19\u0E1A",
    appointmentDate: "\u0E40\u0E27\u0E25\u0E32",
    discountRequestCreatedTitle: "\u0E41\u0E08\u0E49\u0E07\u0E02\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E42\u0E14\u0E22",
    discountRequestCreatedDate: "\u0E02\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E40\u0E21\u0E37\u0E48\u0E2D",
    contractSignedDate: "\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C\u0E2A\u0E31\u0E0D\u0E0D\u0E32\u0E40\u0E21\u0E37\u0E48\u0E2D",
    contractSignedTitle: "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C\u0E2A\u0E31\u0E0D\u0E0D\u0E32\u0E41\u0E25\u0E49\u0E27",
    customerName: "\u0E0A\u0E37\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
    customerFullName: "\u0E0A\u0E37\u0E48\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
    documentAddedDate: "\u0E41\u0E19\u0E1A\u0E44\u0E1F\u0E25\u0E4C",
    discountRequestApprovedDate: "\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E40\u0E21\u0E37\u0E48\u0E2D",
    discountRequestRejectedDate: "\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E40\u0E21\u0E37\u0E48\u0E2D",
    earliestPolicyStartDate: "\u0E27\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E04\u0E38\u0E49\u0E21\u0E04\u0E23\u0E2D\u0E07",
    mailDate: "\u0E15\u0E2D\u0E1A\u0E01\u0E25\u0E31\u0E1A\u0E40\u0E21\u0E37\u0E48\u0E2D",
    mailTitle: "\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E15\u0E2D\u0E1A\u0E01\u0E25\u0E31\u0E1A",
    idCard: "\u0E1A\u0E31\u0E15\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E0A\u0E19",
    leadHumanID: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E35\u0E14",
    leadAssignmentDate: "\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E21\u0E37\u0E48\u0E2D",
    leadAssignmentTitle: "\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E25\u0E35\u0E14",
    leadId: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E35\u0E14",
    mins: "\u0E19\u0E32\u0E17\u0E35",
    noNotification: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E43\u0E19\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49",
    older: "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
    orderId: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E35\u0E14",
    orderQcFailedDate: "\u0E41\u0E08\u0E49\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E40\u0E21\u0E37\u0E48\u0E2D",
    orderQcFailedTitle: "\u0E1B\u0E31\u0E0D\u0E2B\u0E32 QC",
    orderQcFixedDate: "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E21\u0E37\u0E48\u0E2D",
    orderQcFixedTitle: "\u0E1B\u0E31\u0E0D\u0E2B\u0E32 QC \u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E49\u0E27",
    showMore: "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    showUnRead: "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E17\u0E35\u0E48\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E48\u0E32\u0E19",
    title: "\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19",
    today: "\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49",
    with: " ",
    titles: {
      firstNamedDrivingLicense: "\u0E43\u0E1A\u0E02\u0E31\u0E1A\u0E02\u0E35\u0E48\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E02\u0E31\u0E1A\u0E02\u0E35\u0E48\u0E17\u0E35\u0E48 1",
      discountRequestApproved: "\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34",
      discountRequestRejected: "\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E16\u0E39\u0E01\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18",
      idCard: "\u0E1A\u0E31\u0E15\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E0A\u0E19",
      otherDocument: "\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E2D\u0E37\u0E48\u0E19\u0E46",
      paymentSlip: "\u0E2A\u0E25\u0E34\u0E1B",
      secondNamedDrivingLicense: "\u0E43\u0E1A\u0E02\u0E31\u0E1A\u0E02\u0E35\u0E48\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E02\u0E31\u0E1A\u0E02\u0E35\u0E48\u0E17\u0E35\u0E48 2",
      vehicleDashcamPicture: "\u0E23\u0E39\u0E1B\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E15\u0E34\u0E14\u0E23\u0E16\u0E22\u0E19\u0E15\u0E4C",
      vehicleBackPicture: "\u0E23\u0E39\u0E1B\u0E23\u0E16\u0E22\u0E19\u0E15\u0E4C\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E31\u0E07",
      vehicleFrontPicture: "\u0E23\u0E39\u0E1B\u0E23\u0E16\u0E22\u0E19\u0E15\u0E4C\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E19\u0E49\u0E32",
      vehicleLeftPicture: "\u0E23\u0E39\u0E1B\u0E23\u0E16\u0E22\u0E19\u0E15\u0E4C\u0E14\u0E49\u0E32\u0E19\u0E0B\u0E49\u0E32\u0E22",
      vehicleRightPicture: "\u0E23\u0E39\u0E1B\u0E23\u0E16\u0E22\u0E19\u0E15\u0E4C\u0E14\u0E49\u0E32\u0E19\u0E02\u0E27\u0E32",
      vehicleRegistration: "\u0E40\u0E25\u0E48\u0E21\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E23\u0E16\u0E22\u0E19\u0E15\u0E4C"
    }
  },
  select: "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01"
};

// src/Context/index.tsx
var initialContextData = {
  t: (str) => str
};
var Context = createContext(initialContextData);
function UIContext({ children, i18nInstance }) {
  useEffect2(() => {
    i18nInstance?.addResourceBundle("en", "alphafoundersUi", en_default);
    i18nInstance?.addResourceBundle("th", "alphafoundersUi", th_default);
  }, []);
  const translate = useMemo(
    () => ({
      t: (str) => i18nInstance ? i18nInstance.t(`alphafoundersUi:${str}`) : str
    }),
    []
  );
  return /* @__PURE__ */ React9.createElement(Context.Provider, { value: translate }, children);
}
var Context_default = UIContext;

// src/Context/useUIContext.tsx
function useUIContext() {
  const ctx = useContext(Context);
  return ctx;
}
var useUIContext_default = useUIContext;

// src/common/Buttons/DropdownButton.tsx
import { ArrowDownIcon } from "@alphafounders/icons";

// src/utils/clickAwayListener.ts
import { useEffect as useEffect3 } from "react";
function ClickAwayListener(ref, action) {
  useEffect3(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        action();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [action, ref]);
}

// src/common/Buttons/DropdownButton.tsx
function DropdownButton({
  options,
  text = "",
  classes = ""
}) {
  const [isShowDropdown, setShowDropdown] = useState(false);
  const { t } = useUIContext_default();
  const ref = useRef2(null);
  const triggerDropdown = () => {
    setShowDropdown((prev) => !prev);
  };
  ClickAwayListener(ref, () => setShowDropdown(false));
  return /* @__PURE__ */ React11.createElement("div", { className: "relative w-full", ref, "data-testid": "dropdownButton" }, /* @__PURE__ */ React11.createElement(
    "div",
    {
      className: "text-primary rounded-lg text-sm px-4 py-2.5 text-center items-center border-1 border-solid border-[#b0c6e3] bg-white flex gap-2",
      onClick: triggerDropdown,
      onKeyDown: triggerDropdown,
      role: "button",
      tabIndex: 0
    },
    /* @__PURE__ */ React11.createElement("span", { className: "w-full overflow-hidden", title: text || t("select") }, text || t("select")),
    /* @__PURE__ */ React11.createElement(ArrowDownIcon, null)
  ), /* @__PURE__ */ React11.createElement("div", { className: "absolute z-[1200] top-11 left-2 bg-white rounded-lg shadow min-w-54" }, /* @__PURE__ */ React11.createElement(
    "ul",
    {
      className: clsx9(
        "m-0 bg-white p-1 text-sm text-gray-700 list-none border-1 border-solid border-gray-200 max-h-[240px] overflow-y-auto",
        {
          hidden: !isShowDropdown,
          [classes]: true
        }
      )
    },
    options?.length ? (0, import_orderBy.default)(options, ["isPrimary", "name"], ["desc", "asc"]).map(
      (list) => /* @__PURE__ */ React11.createElement(
        "li",
        {
          key: list.id,
          "data-testid": "dropdownButtonList",
          className: clsx9(
            "flex justify-between items-center w-auto leading-4 p-2 hover:bg-gray-200 border-0 border-l-2 border-solid border-transparent",
            {
              "border-primary": list?.isPrimary
            }
          ),
          onClick: list?.onClick,
          onKeyDown: list?.onClick,
          role: "button",
          tabIndex: 0
        },
        list.name,
        /* @__PURE__ */ React11.createElement("span", null, list?.actionElem)
      )
    ) : /* @__PURE__ */ React11.createElement("li", { "data-testid": "noData", className: "p-2" }, t("noData"))
  )));
}
var DropdownButton_default = DropdownButton;

// src/common/Buttons/ContactButton.tsx
import clsx10 from "clsx";
import React12 from "react";
import { twMerge as twMerge2 } from "tailwind-merge";
function ContactButton({
  href,
  imagePath,
  altText,
  className,
  ariaLabel,
  icon
}) {
  return /* @__PURE__ */ React12.createElement(
    AnchorButton_default,
    {
      href,
      target: "_blank",
      rel: "noreferrer",
      "aria-label": ariaLabel ?? null,
      className: twMerge2(
        clsx10(
          "bg-primary border-primary hover:md:bg-primary-dark",
          "w-[26px] h-[26px] sm:h-[1.875rem] sm:w-[1.875rem] lg:h-[2.25rem] lg:w-[2.25rem] p-0"
        ),
        className
      ),
      icon: icon ?? /* @__PURE__ */ React12.createElement("img", { src: imagePath, alt: altText })
    }
  );
}
var ContactButton_default = ContactButton;

// src/common/Buttons/CustomerPortalButton.tsx
import clsx11 from "clsx";
import React13 from "react";
import { twMerge as twMerge3 } from "tailwind-merge";
import { CustomerIcon, CustomerIconWhite } from "@alphafounders/icons";
function CustomerPortalButton({
  href,
  text,
  className,
  icon,
  target
}) {
  return /* @__PURE__ */ React13.createElement(
    AnchorButton_default,
    {
      href,
      "aria-label": "Login to my account",
      target,
      className: twMerge3(
        clsx11(
          "p-0 md:w-auto md:px-2 space-x-0 md:space-x-2 hover:cursor-pointer",
          "w-[26px] h-[26px] sm:h-[1.875rem] sm:w-[1.875rem] lg:h-[2.25rem]",
          "bg-primary text-white fill-primary md:fill-white",
          "border-primary hover:border-primary-dark hover:bg-primary-dark",
          icon && "md:border-primary md:bg-primary border-none bg-transparent"
        ),
        className
      )
    },
    icon ?? /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(CustomerIcon, { className: "hidden md:block" }), /* @__PURE__ */ React13.createElement(CustomerIconWhite, { className: "md:hidden" })),
    /* @__PURE__ */ React13.createElement("div", { className: "hidden md:flex flex-col pr-0.5" }, /* @__PURE__ */ React13.createElement("span", { className: "font-bold text-sm" }, text))
  );
}
var CustomerPortalButton_default = CustomerPortalButton;

// src/common/Buttons/HamburgerButton.tsx
import React14 from "react";
import { twMerge as twMerge4 } from "tailwind-merge";
function HamburgerButton({ isOpen = false, onClick, className }) {
  const pathStyle = {
    transition: "stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1), stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1)",
    strokeDasharray: isOpen ? "90 207" : "60 207",
    strokeDashoffset: isOpen ? "-134" : "0"
  };
  return /* @__PURE__ */ React14.createElement(
    "svg",
    {
      className: twMerge4(
        "stroke-primary cursor-pointer w-[1.5rem] h-[1.5rem] sm:w-[2.5rem] sm:h-[2.5rem]",
        className
      ),
      viewBox: "0 0 100 100",
      onClick,
      "aria-label": "Hamburger Menu",
      role: "img"
    },
    /* @__PURE__ */ React14.createElement(
      "path",
      {
        className: "fill-transparent stroke-[6px]",
        style: pathStyle,
        d: "M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
      }
    ),
    /* @__PURE__ */ React14.createElement(
      "path",
      {
        className: "stroke-[6px]",
        style: {
          transition: "stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1), stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1)",
          strokeDasharray: isOpen ? "1 60" : "60 60",
          strokeDashoffset: isOpen ? "-30" : "0"
        },
        d: "M 20,50 H 80"
      }
    ),
    /* @__PURE__ */ React14.createElement(
      "path",
      {
        className: "fill-transparent stroke-[6px]",
        style: pathStyle,
        d: "M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
      }
    )
  );
}
var HamburgerButton_default = HamburgerButton;

// src/common/Buttons/LanguageButton.tsx
import clsx12 from "clsx";
import React15 from "react";
import { twMerge as twMerge5 } from "tailwind-merge";
function LanguageButton({
  text,
  code,
  dataTestId,
  selected,
  onClick,
  className
}) {
  const handleClick = () => {
    if (!onClick) return;
    onClick(code);
  };
  return /* @__PURE__ */ React15.createElement(
    "div",
    {
      role: "button",
      "data-testid": dataTestId,
      className: twMerge5(
        clsx12(
          "w-[26px] h-[26px] sm:h-[1.875rem] sm:w-[1.875rem] md:h-[2.25rem] md:w-[2.25rem] cursor-pointer",
          "flex max-h-[2.625rem] justify-center items-center no-underline rounded-full",
          "p-2 border border-solid space-x-2",
          [
            selected ? "bg-primary text-white border-primary" : "bg-white text-primary border-muted-light hover:border-primary hover:bg-primary-light"
          ]
        ),
        className
      ),
      onClick: () => handleClick()
    },
    /* @__PURE__ */ React15.createElement("span", { className: "text-xs sm:text-sm font-medium" }, text)
  );
}
var LanguageButton_default = LanguageButton;

// src/common/Buttons/PhoneButton.tsx
import clsx13 from "clsx";
import React16 from "react";
import { twMerge as twMerge6 } from "tailwind-merge";
import { PhoneIcon } from "@alphafounders/icons";
function PhoneButton({ number, subText, className }) {
  return /* @__PURE__ */ React16.createElement(
    AnchorButton_default,
    {
      href: `tel:${number}`,
      "aria-label": "Call Us",
      className: twMerge6(
        clsx13(
          `bg-primary border-primary fill-white md:fill-primary`,
          "md:bg-white md:border-muted-light md:text-primary",
          "md:hover:border-primary-dark md:hover:bg-primary-light",
          "w-[26px] h-[26px] sm:h-[30px] sm:w-[30px]",
          "md:h-[1.875rem] md:w-auto lg:h-[42px] lg:w-auto",
          "p-0 sm:px-[0.4375rem] lg:px-[1.25rem] lg:py-0"
        ),
        className
      ),
      icon: /* @__PURE__ */ React16.createElement(PhoneIcon, null)
    },
    /* @__PURE__ */ React16.createElement("div", { className: "hidden md:flex flex-col ml-2" }, /* @__PURE__ */ React16.createElement("span", { className: "font-bold text-xs lg:text-lg leading-0" }, number), subText && /* @__PURE__ */ React16.createElement("div", { className: "-mt-[0.625rem] sm:hidden lg:block" }, /* @__PURE__ */ React16.createElement("span", { className: "leading-[0.875rem] text-small" }, subText)))
  );
}
var PhoneButton_default = PhoneButton;

// src/common/Buttons/FloatingButton.tsx
import clsx14 from "clsx";
import React17 from "react";
var FloatingButtons = ({
  icon,
  label,
  className,
  floatingButtons = []
}) => {
  return /* @__PURE__ */ React17.createElement("div", { className: "relative inline-block group" }, /* @__PURE__ */ React17.createElement(
    Button_default,
    {
      className: clsx14("bg-blue-500 text-white p-4 rounded-full", className),
      text: label,
      icon
    }
  ), floatingButtons.map((button, index) => /* @__PURE__ */ React17.createElement(
    Button_default,
    {
      variant: "custom",
      key: index,
      rounded: true,
      className: clsx14(
        `absolute ${button.position} text-primary !shadow-lg bg-white min-h-6 min-w-6 p-2 opacity-0 group-hover:opacity-100 transform transition-all duration-300 !z-20 ease-in-out -translate-y-3 group-hover:translate-y-0 border border-transparent hover:!translate-y-3 hover:border-primary`,
        button?.className
      ),
      onClick: button.onClick,
      icon: button?.icon,
      text: button?.label
    }
  )));
};
var FloatingButton_default = FloatingButtons;

// src/common/Price.tsx
import clsx15 from "clsx";
import React18 from "react";

// src/utils/price.ts
var getFormattedPrice = (price) => {
  return price?.toLocaleString();
};

// src/common/Price.tsx
var getClassName = (variant) => {
  switch (variant) {
    case "normal":
      return "text-black";
    case "oldPrice":
      return "text-black line-through";
    case "newPrice":
      return "text-red-500";
    default:
      return "";
  }
};
function Price({
  value,
  variant = "normal",
  className = "",
  ...rest
}) {
  return /* @__PURE__ */ React18.createElement(
    "span",
    {
      className: clsx15(getClassName(variant), className),
      "data-testid": rest["data-testid"]
    },
    getFormattedPrice(value)
  );
}
var Price_default = Price;

// src/common/Installment.tsx
import React19 from "react";
function Installment({
  firstMonthPayment,
  nextMonthPayment,
  installmentMonth,
  totalFee
}) {
  const { t } = useUIContext_default();
  const initialPayment = `${firstMonthPayment} ${t("THB")}`;
  const installment = `${installmentMonth} x ${nextMonthPayment} ${t("THB")}`;
  return /* @__PURE__ */ React19.createElement("ul", { className: "p-0 my-1 pl-4" }, firstMonthPayment && /* @__PURE__ */ React19.createElement("li", { className: "text-base font-normal" }, initialPayment), nextMonthPayment && /* @__PURE__ */ React19.createElement("li", { className: "text-base font-normal" }, installment), totalFee && /* @__PURE__ */ React19.createElement("li", { className: "text-base font-normal" }, `${totalFee} ${t("THB")} `, /* @__PURE__ */ React19.createElement("span", null, "(Fee)")));
}
var Installment_default = Installment;

// src/common/Select.tsx
import React20 from "react";
import clsx16 from "clsx";
function Select({
  options,
  value,
  onSelect,
  className,
  title,
  stopPropagating = false,
  ...rest
}) {
  const preventPropagation = (e) => {
    if (stopPropagating) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return /* @__PURE__ */ React20.createElement(
    "select",
    {
      title: `select-${title}`,
      value,
      onChange: (e) => onSelect(parseInt(e.target.value, 10), e),
      className: clsx16(
        "text-lg font-semibold m-0 outline-none border-none bg-white text-primary",
        className
      ),
      "data-testid": rest["data-testid"],
      onClick: preventPropagation
    },
    options.map((option) => /* @__PURE__ */ React20.createElement("option", { key: option.id, value: option.value }, option.title))
  );
}
var Select_default = Select;

// src/common/Container.tsx
import clsx17 from "clsx";
import React21 from "react";
function Container({
  children,
  className = ""
}) {
  return /* @__PURE__ */ React21.createElement("div", { className: clsx17("w-container mx-auto p-2", className) }, children);
}
var Container_default = Container;

// src/common/Rating.tsx
import React22 from "react";
import clsx18 from "clsx";
import { StarIcon } from "@alphafounders/icons";
function Rating({ rating, className }) {
  return /* @__PURE__ */ React22.createElement("div", { className: clsx18(className) }, /* @__PURE__ */ React22.createElement("div", { className: "inline mx-1" }, /* @__PURE__ */ React22.createElement(StarIcon, null)), /* @__PURE__ */ React22.createElement("div", { className: "inline mx-1" }, rating.toFixed(2)));
}
var Rating_default = Rating;

// src/common/Badge.tsx
import React23 from "react";
import clsx19 from "clsx";
var getVariantClass3 = (variant) => {
  switch (variant) {
    case "primary":
      return "bg-primary";
    case "warning":
      return "bg-warning";
    default:
      return "";
  }
};
function Badge({
  children,
  badge,
  variant = "primary"
}) {
  return /* @__PURE__ */ React23.createElement("div", { className: "inline-flex relative items-center p-3 my-2" }, children, badge && /* @__PURE__ */ React23.createElement(
    "div",
    {
      className: clsx19(
        "inline-flex absolute -top-2 -right-2 justify-center items-center py-1 px-2 text-small text-white rounded-full",
        getVariantClass3(variant)
      )
    },
    badge
  ));
}
var Badge_default = Badge;

// src/package/common/InfoSection.tsx
import React27 from "react";

// src/package/common/InfoTitle.tsx
import React24 from "react";
function InfoTitle({ text }) {
  return /* @__PURE__ */ React24.createElement("div", { className: "text-primary font-bold bg-white text-lg py-[20px] border-0 border-b-[1px] border-solid border-muted-light" }, text);
}
var InfoTitle_default = InfoTitle;

// src/package/common/InfoRow.tsx
import React26, { useMemo as useMemo2 } from "react";

// src/utils/Array.ts
var insertInterval = (array, interval, item) => {
  const newArray = array.slice();
  const step = interval + 1;
  let pos = interval;
  while (pos < newArray.length) {
    newArray.splice(pos, 0, item);
    pos += step;
  }
  return newArray;
};

// src/package/common/InfoContent.tsx
import React25 from "react";
function InfoContent({ content, label }) {
  return /* @__PURE__ */ React25.createElement("div", { className: "w-[415px] px-3 py-2 text-left grow" }, /* @__PURE__ */ React25.createElement("p", { className: "my-1.5 text-muted-dark text-base font-bold" }, label), /* @__PURE__ */ React25.createElement("p", { className: "my-1.5 text-medium leading-6" }, content.component));
}
var InfoContent_default = InfoContent;

// src/package/common/InfoRow.tsx
function InfoRow({ items, packages }) {
  const Contents = useMemo2(() => {
    const contents = packages.map((key) => /* @__PURE__ */ React26.createElement(InfoContent_default, { content: items.values[key], label: items.label }));
    return insertInterval(
      contents,
      1,
      /* @__PURE__ */ React26.createElement(Divider_default, { orientation: "vertical", variant: "secondary" })
    );
  }, [items, packages]);
  return /* @__PURE__ */ React26.createElement("div", { className: "flex flex-row border-0 border-b-[1px] border-solid border-muted-light divide-x even:bg-[#f2f3fa]" }, Contents);
}
var InfoRow_default = InfoRow;

// src/package/common/InfoSection.tsx
function InfoSection({ data }) {
  if (!data.hasData) {
    return null;
  }
  return /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(InfoTitle_default, { text: data.title }), data.items.map((x) => /* @__PURE__ */ React27.createElement(InfoRow_default, { items: x, packages: data.packages, key: x.label })));
}
var InfoSection_default = InfoSection;

// src/package/common/InfoContainer.tsx
import React28 from "react";
function InfoContainer({ children }) {
  return /* @__PURE__ */ React28.createElement("div", { className: "w-fit text-center border border-solid border-muted-light rounded-lg box-border mx-auto" }, children);
}
var InfoContainer_default = InfoContainer;

// src/package/common/DisclaimerSection.tsx
import React29 from "react";
function DisclaimerSection({
  listStyleImage,
  title,
  description
}) {
  const inlineStyle = {
    listStyleImage: listStyleImage ? `url(${listStyleImage})` : void 0
  };
  return /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(InfoTitle_default, { text: title || "Remark" }), /* @__PURE__ */ React29.createElement("div", { className: "text-left text-medium flex flex-row bg-[#f2f3fa]" }, /* @__PURE__ */ React29.createElement("ul", { className: "w-[415px] grow px-3 pl-8 box-sizing", style: inlineStyle }, /* @__PURE__ */ React29.createElement("div", { dangerouslySetInnerHTML: { __html: description || "" } }))));
}
var DisclaimerSection_default = DisclaimerSection;

// src/package/common/InfoLeadCar.tsx
import React30, { useEffect as useEffect4, useState as useState2 } from "react";

// src/utils/window.ts
import moment from "moment";
function isElementInViewport(el) {
  if (el.current == null) {
    return false;
  }
  const rect = el.current.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < document.documentElement.clientHeight;
}
var formatFieldResponse = (field, value) => {
  switch (field) {
    case "doors":
      return `(${value} Doors)`;
    case "month":
      return moment().month(value - 1).format("MMMM");
    case "engineSize":
      return `${value} CC`;
    default:
      return value;
  }
};
var getCarName = (carData) => {
  if (!Object.keys(carData).length) return null;
  const firstLineOrder = carData.isCurated ? ["year", "brand", "model"] : ["year", "brand", "model", "month"];
  const secondLineOrder = carData.isCurated ? ["engineSize", "doors", "cabType", "submodelName", "description"] : [
    "fuelType",
    "engineSize",
    "transmissionType",
    "doors",
    "secondaryBadgeDescription",
    "type"
  ];
  const firstLine = [];
  const secondLine = [];
  firstLineOrder.forEach((order) => {
    if (carData[order]) {
      const formattedResponse = formatFieldResponse(
        order,
        carData[order]
      );
      firstLine.push(formattedResponse);
    }
  });
  secondLineOrder.forEach((order) => {
    if (carData[order]) {
      const formattedResponse = formatFieldResponse(
        order,
        carData[order]
      );
      secondLine.push(formattedResponse);
    }
  });
  return {
    top: firstLine.join(" "),
    bottom: secondLine.join(" ")
  };
};

// src/package/common/InfoLeadCar.tsx
function InfoLeadCar({ title, orderId, carDetails }) {
  const [leadCarInfo, setLeadCarInfo] = useState2(null);
  useEffect4(() => {
    if (carDetails) {
      const carDetail = getCarName(carDetails);
      if (carDetail) {
        setLeadCarInfo({
          carDetail: {
            top: carDetail?.top ?? null,
            bottom: carDetail?.bottom ?? null
          }
        });
      }
    }
  }, [carDetails]);
  return /* @__PURE__ */ React30.createElement("div", { className: "flex flex-col items-center justify-center px-[10px] max-w-[415px] m-auto" }, /* @__PURE__ */ React30.createElement("span", { className: "text-black text-lg" }, title), /* @__PURE__ */ React30.createElement("span", { className: "text-black font-bold text-lg text-center" }, orderId), leadCarInfo?.carDetail?.top && /* @__PURE__ */ React30.createElement(
    "span",
    {
      className: "text-black font-bold text-lg text-center",
      "data-testid": "info-car"
    },
    leadCarInfo?.carDetail?.top
  ), leadCarInfo?.carDetail?.bottom && /* @__PURE__ */ React30.createElement("span", { className: "text-black font-bold text-lg text-center" }, leadCarInfo?.carDetail?.bottom));
}
var InfoLeadCar_default = InfoLeadCar;

// src/notification/NotificationListTemplate.tsx
import React35, { useCallback as useCallback3, useEffect as useEffect7, useState as useState5 } from "react";

// src/utils/useScrollTo.ts
import { useRef as useRef3, useEffect as useEffect5, useState as useState3 } from "react";
var useScrollTo = () => {
  const ref = useRef3(null);
  const [shouldScrollTo, setShouldScrollTo] = useState3(false);
  useEffect5(() => {
    if (ref.current && shouldScrollTo) {
      ref.current.scrollIntoView({ behavior: "smooth" });
      setShouldScrollTo(false);
    }
  }, [shouldScrollTo]);
  return [ref, (isScroll) => setShouldScrollTo(isScroll)];
};
var useScrollTo_default = useScrollTo;

// src/notification/NotificationList.tsx
import clsx23 from "clsx";
import moment4 from "moment";
import React34, { useCallback as useCallback2, useEffect as useEffect6, useState as useState4 } from "react";

// src/common/ProgressBar.tsx
import clsx20 from "clsx";
import React31 from "react";
function ProgressBar({
  shouldAnimate = false,
  bgColor = "bg-gray-200",
  color = "bg-orange-400"
}) {
  return /* @__PURE__ */ React31.createElement(
    "div",
    {
      className: clsx20(
        "w-full bg-muted-dark bg-opacity-25 h-1 relative overflow-hidden",
        bgColor
      )
    },
    /* @__PURE__ */ React31.createElement(
      "div",
      {
        className: clsx20(
          `h-[0.2rem] w-0 absolute left-0`,
          color,
          shouldAnimate && "animate-progress-bar"
        )
      }
    )
  );
}

// src/notification/NotificationList.tsx
import { RedirectIcon as RedirectIcon2 } from "@alphafounders/icons";

// src/notification/helper.tsx
import clsx21 from "clsx";
import moment2 from "moment";
import React32 from "react";
import {
  CalenderIcon,
  ArrowRightCircleIcon,
  DocumentIcon,
  EmailIcon
} from "@alphafounders/icons";

// src/notification/types.ts
var NotificationTypes = /* @__PURE__ */ ((NotificationTypes2) => {
  NotificationTypes2["LEAD_ASSIGNMENT"] = "types/leadAssignment";
  NotificationTypes2["APPOINTMENT"] = "types/appointment";
  NotificationTypes2["QC_FAILED"] = "types/orderQcFailed";
  NotificationTypes2["QC_FIXED"] = "types/orderQcFixed";
  NotificationTypes2["DOCUMENT_ATTACHED"] = "types/documentAdded";
  NotificationTypes2["EMAIL_REPLIED"] = "types/mail";
  NotificationTypes2["DISCOUNT_REQUEST"] = "types/discountRequestDecided";
  NotificationTypes2["APPROVAL_REQUEST"] = "types/discountRequestCreated";
  NotificationTypes2["CONTRACT_SIGNED"] = "types/contractSigned";
  return NotificationTypes2;
})(NotificationTypes || {});

// src/notification/helper.tsx
function GetDocumentTitle(type = "") {
  const { t } = useUIContext_default();
  const documentTypeMap = {
    ["DOCUMENT_TYPE_FIRST_NAMED_DRIVING_LICENCE" /* DOCUMENT_TYPE_FIRST_NAMED_DRIVING_LICENSE */]: "notification.titles.firstNamedDrivingLicense",
    ["DOCUMENT_TYPE_SECOND_NAMED_DRIVING_LICENCE" /* DOCUMENT_TYPE_SECOND_NAMED_DRIVING_LICENSE */]: "notification.titles.secondNamedDrivingLicense",
    ["DOCUMENT_TYPE_PAYMENT_SLIP" /* DOCUMENT_TYPE_PAYMENT_SLIP */]: "notification.titles.paymentSlip",
    ["DOCUMENT_TYPE_VEHICLE_DASHCAM_PICTURE" /* DOCUMENT_TYPE_VEHICLE_DASHCAM_PICTURE */]: "notification.titles.vehicleDashcamPicture",
    ["DOCUMENT_TYPE_VEHICLE_PICTURE_BACK" /* DOCUMENT_TYPE_VEHICLE_PICTURE_BACK */]: "notification.titles.vehicleBackPicture",
    ["DOCUMENT_TYPE_VEHICLE_PICTURE_FRONT" /* DOCUMENT_TYPE_VEHICLE_PICTURE_FRONT */]: "notification.titles.vehicleFrontPicture",
    ["DOCUMENT_TYPE_VEHICLE_PICTURE_LEFT" /* DOCUMENT_TYPE_VEHICLE_PICTURE_LEFT */]: "notification.titles.vehicleLeftPicture",
    ["DOCUMENT_TYPE_VEHICLE_PICTURE_RIGHT" /* DOCUMENT_TYPE_VEHICLE_PICTURE_RIGHT */]: "notification.titles.vehicleRightPicture",
    ["DOCUMENT_TYPE_VEHICLE_REGISTRATION" /* DOCUMENT_TYPE_VEHICLE_REGISTRATION */]: "notification.titles.vehicleRegistration",
    ["DOCUMENT_TYPE_ID_CARD" /* DOCUMENT_TYPE_ID_CARD */]: "notification.titles.idCard",
    ["DOCUMENT_TYPE_OTHERS" /* DOCUMENT_TYPE_OTHERS */]: "notification.titles.otherDocument"
  };
  if (!type || !documentTypeMap[type]) return null;
  return `${t(documentTypeMap[type])} ${t("notification.attached")}`;
}
function getDiscountApprovalTitle(status) {
  const titleMap = {
    ["APPROVED" /* APPROVED */]: "discountRequestApproved",
    ["REJECTED" /* REJECTED */]: "discountRequestRejected"
  };
  return status ? titleMap[status] : false;
}
function TitleAsPerType({
  type,
  description,
  details
}) {
  const { t } = useUIContext_default();
  const {
    customerName,
    leadId,
    documentType,
    status,
    agentTeam,
    agent,
    orderId
  } = details;
  const documentTitle = GetDocumentTitle(documentType ?? "");
  if (type === "types/appointment" /* APPOINTMENT */) {
    return /* @__PURE__ */ React32.createElement(
      "h3",
      {
        className: "text-sm font-bold mb-1 mt-0 text-primary",
        "data-testid": "notification-heading"
      },
      `${description} ${t("notification.with")} ${customerName}`,
      leadId && /* @__PURE__ */ React32.createElement(
        "span",
        {
          "data-testid": "notification-leadId",
          className: "text-[10px] leading-[15px] font-normal"
        },
        ` (${leadId})`
      )
    );
  }
  if (type === "types/documentAdded" /* DOCUMENT_ATTACHED */ && documentType) {
    return /* @__PURE__ */ React32.createElement(
      "h3",
      {
        className: "text-sm font-bold mb-1 mt-0 text-primary max-w-[230px]",
        "data-testid": "notification-heading"
      },
      documentTitle,
      /* @__PURE__ */ React32.createElement("br", null),
      leadId && customerName && /* @__PURE__ */ React32.createElement(
        "span",
        {
          "data-testid": "notification-leadId",
          className: "text-[10px] leading-[15px] font-normal"
        },
        `(${leadId} - ${customerName})`
      )
    );
  }
  if (type === "types/discountRequestDecided" /* DISCOUNT_REQUEST */) {
    const discountTitle = getDiscountApprovalTitle(
      status
    );
    return /* @__PURE__ */ React32.createElement(
      "h3",
      {
        className: "text-sm font-bold mb-1 mt-0 text-primary max-w-[250px]",
        "data-testid": "notification-heading"
      },
      t(`notification.titles.${discountTitle}`),
      /* @__PURE__ */ React32.createElement("br", null),
      customerName,
      leadId && /* @__PURE__ */ React32.createElement(
        "span",
        {
          "data-testid": "notification-leadId",
          className: "text-[10px] leading-[15px] font-normal"
        },
        ` (${leadId})`
      )
    );
  }
  const typeTitle = t(`notification.${type.split("/")[1]}Title`);
  if (type === "types/discountRequestCreated" /* APPROVAL_REQUEST */ && agent) {
    return /* @__PURE__ */ React32.createElement(
      "h3",
      {
        className: "text-sm font-bold mb-1 mt-0 text-primary",
        "data-testid": "notification-heading"
      },
      `${typeTitle} ${agent} - ${agentTeam || ""} (${leadId})`
    );
  }
  return /* @__PURE__ */ React32.createElement(
    "h3",
    {
      className: "text-sm font-bold mb-1 mt-0 text-primary",
      "data-testid": "notification-heading"
    },
    `${typeTitle} - ${customerName}`,
    (leadId || orderId) && /* @__PURE__ */ React32.createElement(
      "span",
      {
        "data-testid": "notification-leadId",
        className: "text-[10px] leading-[15px] font-normal"
      },
      ` (${leadId || orderId})`
    )
  );
}
function DateAsPerType({
  type,
  value,
  className,
  timeValues,
  status
}) {
  const { t } = useUIContext_default();
  const formatDateTime = (from, to) => {
    const _from = moment2(from).utc();
    const _to = moment2(to).utc();
    const difference = _to.diff(_from, "minutes");
    return `${_from.format("hh:mm")} - ${_to.format(
      "hh:mm"
    )} (${difference} ${t("notification.mins")})`;
  };
  const _value = timeValues?.from && type === "types/appointment" /* APPOINTMENT */ ? formatDateTime(timeValues.from, timeValues.to) : value;
  const title = status && type === "types/discountRequestDecided" /* DISCOUNT_REQUEST */ ? getDiscountApprovalTitle(status) : type.split("/")[1];
  return /* @__PURE__ */ React32.createElement("span", { className: clsx21(className ?? ""), "data-testid": "notification-date" }, t(`notification.${title}Date`), "\xA0", _value ?? "");
}
function IconAsPerType({
  type,
  isNewNotifcation = false
}) {
  const variant = isNewNotifcation ? "new" : void 0;
  if ([
    "types/documentAdded" /* DOCUMENT_ATTACHED */,
    "types/discountRequestCreated" /* APPROVAL_REQUEST */,
    "types/contractSigned" /* CONTRACT_SIGNED */
  ].includes(type))
    return /* @__PURE__ */ React32.createElement(DocumentIcon, { variant });
  if (type === "types/appointment" /* APPOINTMENT */)
    return /* @__PURE__ */ React32.createElement(CalenderIcon, { variant });
  if (type === "types/mail" /* EMAIL_REPLIED */)
    return /* @__PURE__ */ React32.createElement(EmailIcon, { variant });
  return /* @__PURE__ */ React32.createElement(ArrowRightCircleIcon, { variant });
}
function isNewLayout(type, flag) {
  const flagsMap = {
    ["types/appointment" /* APPOINTMENT */]: true,
    ["types/leadAssignment" /* LEAD_ASSIGNMENT */]: true,
    ["types/orderQcFailed" /* QC_FAILED */]: true,
    ["types/orderQcFixed" /* QC_FIXED */]: true,
    ["types/documentAdded" /* DOCUMENT_ATTACHED */]: true,
    ["types/discountRequestDecided" /* DISCOUNT_REQUEST */]: true,
    ["types/mail" /* EMAIL_REPLIED */]: true,
    ["types/discountRequestCreated" /* APPROVAL_REQUEST */]: true,
    ["types/contractSigned" /* CONTRACT_SIGNED */]: true
  };
  return type ? flagsMap[type] : false;
}
var ExcludedDetailsFromTable = ["documentType"];

// src/notification/NotificationTemplate.tsx
import clsx22 from "clsx";
import moment3 from "moment";
import React33, { useCallback, useMemo as useMemo3 } from "react";
import { RedirectIcon, NewBellIcon, CloseIcon } from "@alphafounders/icons";
function TableContainer({
  className,
  details,
  description
}) {
  const { t } = useUIContext_default();
  return /* @__PURE__ */ React33.createElement("div", { className: clsx22("table-container mt-2 mb-2", className ?? "") }, Object.entries(details)?.map(([key, value]) => {
    if (ExcludedDetailsFromTable.includes(key)) return null;
    return /* @__PURE__ */ React33.createElement("div", { key: key + value, className: "flex m-0 p-0 pl-[15px] pr-[15px]" }, /* @__PURE__ */ React33.createElement("span", { className: "flex w-1/2 font-bold text-black capitalize" }, t(`notification.${key}`)), /* @__PURE__ */ React33.createElement("span", { className: "pb-[6px] mr-[3px]" }, ":"), /* @__PURE__ */ React33.createElement("span", { className: "flex w-1/2 whitespace-nowrap overflow-hidden text-ellipsis" }, value));
  }), description?.length && /* @__PURE__ */ React33.createElement(
    "p",
    {
      className: "font-medium leading-tight m-1",
      "data-testid": "notification-desc"
    },
    description
  ));
}
function NotificationActions({
  handleClose,
  handleOpen,
  closeBtnText = "close",
  openBtnText = "open"
}) {
  const { t } = useUIContext_default();
  return /* @__PURE__ */ React33.createElement("div", { className: "flex flex-row content-between mt-2" }, /* @__PURE__ */ React33.createElement(
    Button_default,
    {
      variant: "secondary",
      className: "w-full p-3 pl-4 pr-4 mr-2",
      text: t(closeBtnText),
      onClick: handleClose
    }
  ), /* @__PURE__ */ React33.createElement(
    Button_default,
    {
      dataTestId: "notification-redirect-btn",
      className: "w-full p-3 pl-4 pr-4",
      text: t(openBtnText),
      icon: /* @__PURE__ */ React33.createElement(RedirectIcon, { className: "mr-1" }),
      onClick: handleOpen
    }
  ));
}
function NotificationTemplate({
  toastProps,
  closeToast,
  handleRead,
  flag
}) {
  const { t } = useUIContext_default();
  const { title, details, date, description, url, id, type, from, to } = toastProps.data;
  const handleClose = useCallback(() => {
    handleRead?.({
      notificationId: id,
      type,
      readTime: moment3().format("YYYY-MM-DDTHH:mm:ss[Z]")
    });
    closeToast();
  }, [closeToast, handleRead, id, type]);
  const handleOpen = useCallback(() => {
    handleRead?.({
      notificationId: id,
      type,
      readTime: moment3().format("YYYY-MM-DDTHH:mm:ss[Z]")
    });
    if (url) {
      window.open(url, "_blank", "noopener");
    }
    closeToast();
  }, [id, type, url]);
  const titleIcon = useMemo3(() => {
    return /* @__PURE__ */ React33.createElement(IconAsPerType, { type, isNewNotifcation: true });
  }, [type]);
  if (isNewLayout(type, flag)) {
    return /* @__PURE__ */ React33.createElement(
      "div",
      {
        className: "relative font-['Poppins']",
        "data-testid": "notification-template"
      },
      /* @__PURE__ */ React33.createElement(
        "div",
        {
          className: "absolute -right-6 -top-6 rounded-full bg-white p-1.5 w-6 h-6 inline-flex items-center justify-center shadow-closeBtn cursor-pointer",
          "data-testid": "notification-close-btn",
          onClick: handleClose,
          onKeyDown: handleClose,
          tabIndex: 0,
          role: "button"
        },
        /* @__PURE__ */ React33.createElement(CloseIcon, null)
      ),
      /* @__PURE__ */ React33.createElement("div", { className: "flex flex-row justify-items-start" }, /* @__PURE__ */ React33.createElement("div", { className: "shrink-0" }, titleIcon), /* @__PURE__ */ React33.createElement("div", { className: "flex flex-col justify-items-center mx-3" }, /* @__PURE__ */ React33.createElement(
        TitleAsPerType,
        {
          type,
          description,
          details
        }
      ), /* @__PURE__ */ React33.createElement(
        DateAsPerType,
        {
          type,
          value: date ?? null,
          timeValues: !!from && !!to ? { from, to } : void 0,
          className: "text-xs leading-[20px] text-slate-950",
          status: details.status
        }
      )), /* @__PURE__ */ React33.createElement("div", { className: "shrink-0" }, /* @__PURE__ */ React33.createElement(
        "div",
        {
          className: "cursor-pointer",
          "data-testid": "notification-redirect-btn",
          onClick: handleOpen,
          onKeyDown: handleClose,
          tabIndex: 0,
          role: "button"
        },
        /* @__PURE__ */ React33.createElement(RedirectIcon, { fillColor: "#005098" })
      )))
    );
  }
  return /* @__PURE__ */ React33.createElement("div", { className: "relative", "data-testid": "notification-template" }, /* @__PURE__ */ React33.createElement(
    "div",
    {
      className: "absolute right-[-10px] top-[-10px] rounded-full p-[0.2rem] pl-2 pr-2 bg-primary shadow-outline cursor-pointer",
      onClick: handleClose,
      onKeyPress: handleClose,
      tabIndex: 0,
      role: "button"
    },
    /* @__PURE__ */ React33.createElement(CloseIcon, { fillColor: "white", className: "h-2 w-2" })
  ), /* @__PURE__ */ React33.createElement("div", { className: "flex flex-row justify-items-center" }, /* @__PURE__ */ React33.createElement(NewBellIcon, null), /* @__PURE__ */ React33.createElement("div", { className: "flex flex-col justify-items-start" }, /* @__PURE__ */ React33.createElement(
    "h3",
    {
      className: "text-lg font-extrabold m-1 mb-0 mt-0 text-primary",
      "data-testid": "notification-heading"
    },
    t(title)
  ), /* @__PURE__ */ React33.createElement(
    DateAsPerType,
    {
      type,
      value: date ?? null,
      timeValues: !!from && !!to ? { from, to } : void 0
    }
  ))), Object.entries(details).length > 0 && /* @__PURE__ */ React33.createElement(TableContainer, { details }), description?.length && /* @__PURE__ */ React33.createElement(
    "p",
    {
      className: "font-medium leading-tight m-1",
      "data-testid": "notification-desc"
    },
    description
  ), /* @__PURE__ */ React33.createElement(NotificationActions, { handleOpen, handleClose }));
}
var NotificationTemplate_default = NotificationTemplate;

// src/notification/NotificationList.tsx
function TextDivider({ text, total }) {
  return /* @__PURE__ */ React34.createElement("div", { className: "flex flex-row justify-start font-bold text-xs leading-tight  mt-3 mb-2" }, text, `(${total})`);
}
function NotificationList({
  data,
  handleRead,
  isNewLayout: _isNewLayout
}) {
  const [showDetails, setShowDetails] = useState4(false);
  const [isReadingNotification, setIsReadingNotification] = useState4(false);
  const { t } = useUIContext_default();
  const { title, date, isNew, details, url, id, type, description, from, to } = data;
  const documentTitle = GetDocumentTitle(details?.documentType ?? "");
  const triggerReadNotification = useCallback2(() => {
    if (isNew) {
      handleRead?.({
        notificationId: id,
        type,
        readTime: moment4().format("YYYY-MM-DDTHH:mm:ss[Z]")
      });
    }
  }, [isNew, handleRead, id, type]);
  const handleReadAndShowDetails = () => {
    setShowDetails(!showDetails);
    if (isNew) {
      setIsReadingNotification(true);
    }
    triggerReadNotification();
  };
  useEffect6(() => {
    if (!isNew) {
      setIsReadingNotification(false);
    }
  }, [data]);
  const handleReadAndRedirect = useCallback2(() => {
    triggerReadNotification();
    if (url) {
      window.open(url, "_blank", "noopener");
    }
  }, [triggerReadNotification, url]);
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement(
    "div",
    {
      className: clsx23(
        "flex flex-row justify-around rounded p-2 pl-1 pr-1 mb-0 mt-2 items-center cursor-pointer",
        isNew && "bg-slate-100"
      ),
      onClick: handleReadAndShowDetails,
      onKeyPress: handleReadAndShowDetails,
      role: "button",
      tabIndex: 0,
      "data-testid": "details-collapse-btn"
    },
    _isNewLayout ? /* @__PURE__ */ React34.createElement("div", { className: "flex h-5 w-5" }, /* @__PURE__ */ React34.createElement(IconAsPerType, { type, isNewNotifcation: isNew })) : /* @__PURE__ */ React34.createElement("div", { className: "flex relative h-3 w-3" }, /* @__PURE__ */ React34.createElement(
      "span",
      {
        className: clsx23(
          `absolute inline-flex h-full w-full rounded-full opacity-75`,
          {
            "bg-red-500 animate-ping": isNew,
            "bg-muted-dark": !isNew
          }
        )
      }
    ), /* @__PURE__ */ React34.createElement(
      "span",
      {
        className: clsx23(`relative inline-flex rounded-full h-3 w-3`, {
          "bg-red-500": isNew,
          "bg-muted-dark": !isNew
        })
      }
    )),
    _isNewLayout ? /* @__PURE__ */ React34.createElement("div", { className: "flex flex-col justify-items-center mx-3 w-[250px]" }, /* @__PURE__ */ React34.createElement(
      TitleAsPerType,
      {
        type,
        description,
        details
      }
    ), /* @__PURE__ */ React34.createElement(
      DateAsPerType,
      {
        type,
        value: date ?? null,
        timeValues: !!from && !!to ? { from, to } : void 0,
        className: "text-xs leading-[20px] text-slate-950",
        status: details.status
      }
    )) : /* @__PURE__ */ React34.createElement("div", { className: "flex flex-col justify-items-start min-w-[200px]" }, /* @__PURE__ */ React34.createElement("h3", { className: "text-lg font-extrabold m-1 mb-0 mt-0 text-primary" }, documentTitle ?? t(title)), date && /* @__PURE__ */ React34.createElement(
      DateAsPerType,
      {
        className: "mt-2",
        type,
        value: date,
        status: details.status
      }
    )),
    /* @__PURE__ */ React34.createElement(
      Button_default,
      {
        dataTestId: "notification-redirect-btn",
        text: "",
        variant: "secondary",
        className: "border-none bg-transparent",
        icon: /* @__PURE__ */ React34.createElement(
          RedirectIcon2,
          {
            fillColor: "#005098",
            className: "h-4 w-4 cursor-pointer"
          }
        ),
        onClick: handleReadAndRedirect
      }
    )
  ), /* @__PURE__ */ React34.createElement(ProgressBar, { shouldAnimate: isReadingNotification }), showDetails && !_isNewLayout && Object.entries(details).length > 0 && /* @__PURE__ */ React34.createElement("div", { className: "p-2 shadow-sm", "data-testid": "details" }, /* @__PURE__ */ React34.createElement(
    TableContainer,
    {
      details,
      description,
      className: "pl-[1.5rem]"
    }
  )));
}
function NotificationListsGroup({
  data,
  handleRead,
  scrollToRef,
  flags
}) {
  const { t } = useUIContext_default();
  return /* @__PURE__ */ React34.createElement(
    "div",
    {
      className: "mt-3 mb-3 min-h-[380px] max-h-[386px] overflow-y-auto",
      "data-testid": "notification-list"
    },
    /* @__PURE__ */ React34.createElement(TextDivider, { text: t("notification.today"), total: data.today.length }),
    data.today.length ? data.today.map((_list) => /* @__PURE__ */ React34.createElement(
      NotificationList,
      {
        handleRead,
        key: _list.id,
        data: _list,
        isNewLayout: !!isNewLayout(_list.type, flags)
      }
    )) : /* @__PURE__ */ React34.createElement("p", { className: "color-muted-dark text-center" }, t("notification.noNotification")),
    data.older.length ? /* @__PURE__ */ React34.createElement(TextDivider, { text: t("notification.older"), total: data.older.length }) : null,
    data.older?.map((_list) => /* @__PURE__ */ React34.createElement(
      NotificationList,
      {
        handleRead,
        key: _list.id,
        data: _list,
        isNewLayout: !!isNewLayout(_list.type, flags)
      }
    )),
    /* @__PURE__ */ React34.createElement("div", { ref: scrollToRef })
  );
}

// src/notification/NotificationListTemplate.tsx
var initialValue = {
  older: [],
  today: [],
  total: 0,
  token: "",
  unRead: 0
};
function NotificationListTemplate({
  data,
  handleRead,
  setPageToken,
  flags
}) {
  const [isShowUnRead, setShowUnRead] = useState5(false);
  const [unReadNotifications, setUnReadNotifications] = useState5(initialValue);
  const [scrollToRef, setShouldScrollTo] = useScrollTo_default();
  const [isGettingMoreNotification, setGetMoreNotification] = useState5(false);
  const { t } = useUIContext_default();
  const { token } = data;
  useEffect7(() => {
    setShouldScrollTo(true);
  }, [token]);
  const handleShowUnread = useCallback3(
    () => setShowUnRead(!isShowUnRead),
    [isShowUnRead]
  );
  const handleShowMore = useCallback3(() => {
    if (token) {
      setPageToken(token);
      setGetMoreNotification(true);
    }
  }, [setPageToken, token]);
  useEffect7(() => {
    let notificationData = {
      ...initialValue
    };
    Object.entries(data).forEach(
      ([key, _data]) => {
        if (["today", "older"].includes(key) && _data?.length) {
          notificationData[key] = _data.filter(
            (list) => !!list.isNew
          );
        } else {
          notificationData = {
            ...notificationData,
            [key]: _data
          };
        }
      }
    );
    setUnReadNotifications(notificationData);
    setGetMoreNotification(false);
  }, [isShowUnRead, data, handleRead]);
  return /* @__PURE__ */ React35.createElement(
    "div",
    {
      className: "absolute top-[2rem] -right-[3em] z-50 p-2 bg-white translate-y-6 card rounded min-w-[400px] max-h-[500px] drop-shadow-lg overflow-hidden",
      "data-testid": "notification-inbox"
    },
    /* @__PURE__ */ React35.createElement("div", { className: "flex flex-row justify-between  mb-2 mt-2 pl-3 pr-3" }, /* @__PURE__ */ React35.createElement("h3", { className: "flex justify-center text-lg font-extrabold m-1 mb-0 mt-0 text-primary" }, t("notification.title"), ` ( ${unReadNotifications.unRead} )`), /* @__PURE__ */ React35.createElement("div", { className: "flex flex-row justify-items-center" }, /* @__PURE__ */ React35.createElement("span", { className: "text-sm leading-tight text-primary" }, /* @__PURE__ */ React35.createElement(
      ToggleSwitch,
      {
        label: t("notification.showUnRead"),
        checked: isShowUnRead,
        onClick: handleShowUnread
      }
    )))),
    /* @__PURE__ */ React35.createElement(
      NotificationListsGroup,
      {
        scrollToRef,
        data: isShowUnRead ? unReadNotifications : data,
        handleRead,
        flags
      }
    ),
    !!token && /* @__PURE__ */ React35.createElement(
      Button_default,
      {
        onClick: handleShowMore,
        dataTestId: "readmore-button",
        isLoading: isGettingMoreNotification,
        text: t("notification.showMore"),
        variant: "secondary",
        className: "text-center w-full p-3"
      }
    )
  );
}
var NotificationListTemplate_default = NotificationListTemplate;

// src/Appointment/DayCard.tsx
import clsx24 from "clsx";
import React36, { useEffect as useEffect8 } from "react";
function DayCard({
  id,
  day,
  date,
  free,
  paymentCall,
  appointment,
  loading,
  onClick,
  active = false,
  disabled = false
}) {
  const { t } = useUIContext_default();
  const [cardRef, scroll] = useScrollTo_default();
  const handleClick = (e) => {
    if (disabled) {
      return;
    }
    onClick?.(id, e);
  };
  useEffect8(() => {
    scroll(active);
  }, [active, scroll]);
  return /* @__PURE__ */ React36.createElement(
    "div",
    {
      className: clsx24(
        "min-w-[10.625rem] h-[8rem] border rounded-xl border-muted-light border-solid px-3 py-5 cursor-pointer",
        {
          "bg-muted-light opacity-50": disabled,
          "bg-primary-light border-2 border-primary": active
        }
      ),
      "data-testid": `daycard-${id}`,
      role: "button",
      tabIndex: 0,
      onKeyDown: () => null,
      onClick: handleClick,
      ref: cardRef
    },
    loading ? /* @__PURE__ */ React36.createElement("div", { role: "status", className: "animate-pulse", "data-testid": "card-loading" }, /* @__PURE__ */ React36.createElement("div", { className: "h-8 bg-muted-light rounded my-4" }), /* @__PURE__ */ React36.createElement("div", { className: "h-2 bg-muted-light rounded my-2" }), /* @__PURE__ */ React36.createElement("div", { className: "h-2 bg-muted-light rounded my-2" }), /* @__PURE__ */ React36.createElement("div", { className: "h-2 bg-muted-light rounded my-2" })) : /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement("div", { className: "font-bold text-lg mt-1" }, day), /* @__PURE__ */ React36.createElement("div", { className: "text-medium" }, `(${date})`), /* @__PURE__ */ React36.createElement("div", { className: "flex justify-between my-2 font-normal text-base" }, /* @__PURE__ */ React36.createElement("div", null, t("numberOfFreeSlot")), /* @__PURE__ */ React36.createElement("div", null, free)), /* @__PURE__ */ React36.createElement("div", { className: "flex justify-between my-2 font-normal text-base" }, /* @__PURE__ */ React36.createElement("div", null, t("numberOfPaymentCall")), /* @__PURE__ */ React36.createElement("div", { className: "text-red-600" }, paymentCall)), /* @__PURE__ */ React36.createElement("div", { className: "flex justify-between my-2 font-normal text-base" }, /* @__PURE__ */ React36.createElement("div", null, t("numberOfAppointment")), /* @__PURE__ */ React36.createElement("div", { className: "text-success" }, appointment)))
  );
}
var DayCard_default = DayCard;

// src/Appointment/index.tsx
import React37 from "react";
import { ArrowLeftOutline, ArrowRightOutline } from "@alphafounders/icons";
import clsx25 from "clsx";
function AppointmentModal({
  timeSlots,
  Inputs,
  days,
  onAddClick,
  onCancelClick,
  onLeftArrowClick,
  onRightArrowClick,
  loading,
  submitting = false,
  showCancelBtn = true,
  disableSubmit = false,
  disableLeftArrow = false,
  disableRightArrow = false,
  isViewOnly = false,
  includeTitleBar = true
}) {
  const { t } = useUIContext_default();
  return /* @__PURE__ */ React37.createElement("div", { className: "max-w-[1350px]", "data-testid": "appointment-modal" }, includeTitleBar && /* @__PURE__ */ React37.createElement("div", { className: "rounded-t-[20px] bg-primary text-white p-4 font-bold text-[18px] text-center" }, t("appointment")), /* @__PURE__ */ React37.createElement(
    "form",
    {
      className: clsx25(
        "py-5 px-7 bg-white rounded-b-[1.25rem] overflow-x-scroll",
        { "max-h-[80vh]": includeTitleBar }
      )
    },
    /* @__PURE__ */ React37.createElement("div", { className: "flex flex-wrap gap-[20px]" }, Inputs.map(({ id, label, Component }) => /* @__PURE__ */ React37.createElement("div", { key: id, className: "w-[20%] min-w-[300px] grow" }, /* @__PURE__ */ React37.createElement("div", { className: "py-2" }, label), Component))),
    /* @__PURE__ */ React37.createElement("div", { className: "flex items-center my-6 justify-center" }, /* @__PURE__ */ React37.createElement(
      "button",
      {
        type: "button",
        "data-testid": "left-arrow",
        className: "inline-flex p-3 text-primary border-0 bg-white cursor-pointer hover:bg-muted-light disabled:text-muted-dark",
        onClick: onLeftArrowClick,
        disabled: disableLeftArrow
      },
      /* @__PURE__ */ React37.createElement(ArrowLeftOutline, null)
    ), /* @__PURE__ */ React37.createElement("div", { className: "inline-flex gap-3 overflow-x-scroll" }, loading ? Array.from({ length: 5 }, (x, i) => i.toString()).map((p) => (
      // eslint-disable-next-line react/jsx-indent
      /* @__PURE__ */ React37.createElement(DayCard_default, { key: p, id: p, loading: true })
    )) : days.map((p) => /* @__PURE__ */ React37.createElement(DayCard_default, { key: p.id, ...p }))), /* @__PURE__ */ React37.createElement(
      "button",
      {
        type: "button",
        "data-testid": "right-arrow",
        className: "inline-flex p-3 text-primary border-0 bg-white cursor-pointer hover:bg-muted-light disabled:text-muted-dark",
        onClick: onRightArrowClick,
        disabled: disableRightArrow
      },
      /* @__PURE__ */ React37.createElement(ArrowRightOutline, null)
    )),
    !isViewOnly && /* @__PURE__ */ React37.createElement("div", null, t("selectTheTime")),
    /* @__PURE__ */ React37.createElement("div", { className: "mt-2 flex flex-wrap gap-3" }, timeSlots),
    !isViewOnly && /* @__PURE__ */ React37.createElement("div", { className: "flex justify-center my-4 gap-5" }, showCancelBtn && /* @__PURE__ */ React37.createElement(
      Button_default,
      {
        className: "px-6 py-3",
        text: t("cancel"),
        variant: "secondary",
        onClick: onCancelClick
      }
    ), /* @__PURE__ */ React37.createElement(
      Button_default,
      {
        className: "px-8 py-3",
        text: t("save"),
        isLoading: submitting,
        onClick: onAddClick,
        disabled: disableSubmit
      }
    ))
  ));
}
var Appointment_default = AppointmentModal;

// src/common/HelpTool/index.tsx
import clsx26 from "clsx";
import React39 from "react";
import { QuestionCircle } from "@alphafounders/icons";

// src/common/HelpTool/CustomTooltip.tsx
import React38 from "react";
import { Tooltip as BaseTooltip } from "react-tippy";
var Tooltip = BaseTooltip;
function CustomTooltip(props) {
  return /* @__PURE__ */ React38.createElement(Tooltip, { ...props });
}
var CustomTooltip_default = CustomTooltip;

// src/common/HelpTool/index.tsx
function HelpTool({
  tip,
  extraClasses,
  position = "bottom",
  trigger,
  arrow = true,
  label,
  html
}) {
  return /* @__PURE__ */ React39.createElement(
    "button",
    {
      "data-testid": "tooltip-icon",
      className: clsx26("ml-2 mt-0.5", [extraClasses])
    },
    /* @__PURE__ */ React39.createElement(
      CustomTooltip_default,
      {
        title: tip,
        html,
        position,
        trigger,
        arrow
      },
      label ? /* @__PURE__ */ React39.createElement("span", null, label) : /* @__PURE__ */ React39.createElement(QuestionCircle, { className: "w-[15px] h-[15px]" })
    )
  );
}
var HelpTool_default = HelpTool;

// src/common/Tab/index.tsx
import React43, { useState as useState6 } from "react";

// src/common/Tab/TabHeaders/Contained.tsx
import React41 from "react";
import clsx27 from "clsx";

// src/common/Tab/TabBadge.tsx
import React40 from "react";
function TabBadge({ badge }) {
  return /* @__PURE__ */ React40.createElement(React40.Fragment, null, badge && /* @__PURE__ */ React40.createElement("div", { className: "inline-flex text-xs font-normal text-white rounded bg-danger ml-2 px-1 pr-1.5", "data-testid": "tab-badge" }, badge));
}
var TabBadge_default = TabBadge;

// src/common/Tab/TabHeaders/Contained.tsx
function TabContainedHeader({
  tabs,
  activeTab,
  setActiveTab,
  onTabChange = () => void 0
}) {
  const onTabHeaderClick = (tab) => {
    setActiveTab(tab);
    onTabChange(tab);
  };
  return /* @__PURE__ */ React41.createElement("div", { "data-testid": "tab-contained-header" }, /* @__PURE__ */ React41.createElement("ul", { className: "m-0 p-0 list-none flex flex-wrap text-sm font-medium text-center" }, tabs.map((tab) => /* @__PURE__ */ React41.createElement("li", { className: "mr-1", key: tab?.id }, /* @__PURE__ */ React41.createElement(
    "button",
    {
      type: "button",
      className: clsx27(
        activeTab?.id === tab?.id ? "bg-primary text-white" : "bg-white text-primary",
        "inline-block border-x border-y border-solid border-line cursor-pointer py-3 px-6 font-bold text-sm rounded-t-10 active"
      ),
      onClick: () => onTabHeaderClick(tab)
    },
    tab?.icon && /* @__PURE__ */ React41.createElement(
      "span",
      {
        className: "mr-2 relative pr-4 [&_svg]:absolute [&_svg]:h-4",
        "data-testid": "tab-icon"
      },
      tab?.icon
    ),
    /* @__PURE__ */ React41.createElement("span", null, tab?.title),
    tab?.badge && /* @__PURE__ */ React41.createElement(TabBadge_default, { badge: tab?.badge })
  )))));
}

// src/common/Tab/TabHeaders/Underline.tsx
import React42 from "react";
import clsx28 from "clsx";
function TabUnderlineHeader({
  tabs,
  activeTab,
  setActiveTab
}) {
  return /* @__PURE__ */ React42.createElement("div", { "data-testid": "tab-underline-header" }, /* @__PURE__ */ React42.createElement("ul", { className: "m-0 p-0 border-x-0 border-t-0 border-b border-solid border-line list-none flex flex-wrap text-sm font-medium text-center text-gray-500" }, tabs.map((tab) => /* @__PURE__ */ React42.createElement("li", { className: "mr-1 flex flex-col items-center", key: tab?.id }, /* @__PURE__ */ React42.createElement(
    "button",
    {
      type: "button",
      className: clsx28(
        activeTab?.id === tab?.id ? "text-primary" : "text-slate-950",
        "inline-block border-0 bg-white cursor-pointer py-3 px-6 font-bold text-sm"
      ),
      onClick: () => setActiveTab(tab)
    },
    tab?.icon && /* @__PURE__ */ React42.createElement("span", { className: "mr-2 relative pr-3 [&_svg]:absolute [&_svg]:h-4" }, tab?.icon),
    tab?.title,
    tab?.badge && /* @__PURE__ */ React42.createElement(TabBadge_default, { badge: tab?.badge })
  ), activeTab?.id === tab?.id && /* @__PURE__ */ React42.createElement("div", { className: "bg-primary h-1 w-[51px] rounded-t" })))));
}

// src/common/Tab/index.tsx
function Tab({
  tabs,
  variant = "contained",
  tabToActive,
  onTabChange = () => void 0,
  children
}) {
  const getActiveTab = tabToActive && tabs?.length > 0 ? tabs?.find((tab) => tab.id === tabToActive) : tabs?.[0];
  const [activeTab, setActiveTab] = useState6(getActiveTab);
  const tabHeaderProps = {
    tabs,
    activeTab,
    setActiveTab,
    onTabChange
  };
  return /* @__PURE__ */ React43.createElement(React43.Fragment, null, variant === "contained" /* CONTAINED */ && /* @__PURE__ */ React43.createElement(TabContainedHeader, { ...tabHeaderProps }), variant === "underline" /* UNDERLINE */ && /* @__PURE__ */ React43.createElement(TabUnderlineHeader, { ...tabHeaderProps }), /* @__PURE__ */ React43.createElement("div", { "data-testid": "tab-content", className: "overflow-scroll" }, children));
}
var Tab_default = Tab;

// src/common/Checkbox/index.tsx
import clsx29 from "clsx";
import React44 from "react";
function Checkbox({
  dataTestId,
  onChange,
  label,
  smallLabel,
  description,
  value,
  checked = false,
  disabled = false,
  className = "",
  checkboxSize = "normal"
}) {
  return /* @__PURE__ */ React44.createElement("div", { className: `flex ${className}` }, /* @__PURE__ */ React44.createElement(
    "input",
    {
      type: "checkbox",
      "data-testid": dataTestId,
      className: clsx29("flex pr-3 justify-center items-center p-2 mt-1", {
        "accent-primary": checked,
        "h-6 w-6": checkboxSize === "large",
        "h-4 w-4": checkboxSize === "normal"
      }),
      value,
      onChange,
      checked,
      disabled
    }
  ), label && /* @__PURE__ */ React44.createElement("label", { htmlFor: "input", className: "pl-2 max-w-[95%]" }, /* @__PURE__ */ React44.createElement("div", { className: "flex flex-col" }, /* @__PURE__ */ React44.createElement("span", { className: "text-base font-bold leading-6" }, label), smallLabel && /* @__PURE__ */ React44.createElement("span", { className: "text-base font-normal mt-1 leading-5" }, smallLabel), description && /* @__PURE__ */ React44.createElement("span", { className: "text-xs font-normal mt-1 text-lightgray" }, description))));
}
var Checkbox_default = Checkbox;

// src/common/RadioGroup/index.tsx
import clsx30 from "clsx";
import React46 from "react";

// src/common/RadioGroup/Radio/index.tsx
import React45 from "react";
function Radio({
  dataTestId,
  value,
  selected = false,
  disabled = false,
  onChange,
  label,
  name,
  id = name,
  radioType = "circle"
}) {
  return /* @__PURE__ */ React45.createElement("div", { className: "grid grid-cols-[auto,1fr] gap-2 items-center pb-2 pr-2" }, /* @__PURE__ */ React45.createElement("div", { className: "relative" }, /* @__PURE__ */ React45.createElement(
    "input",
    {
      type: "radio",
      id,
      name,
      "data-testid": dataTestId ?? `radio-${name}-${value}`,
      className: "opacity-0 absolute m-0 p-0 w-4 h-4 z-20 peer cursor-pointer disabled:cursor-default",
      value,
      checked: selected,
      onChange: (e) => onChange(e, value),
      disabled
    }
  ), radioType === "circle" && /* @__PURE__ */ React45.createElement(
    "span",
    {
      className: "\n            content-['']\n            block\n            relative\n            top-0\n            left-0\n            w-4\n            h-4\n            min-w-4\n            min-h-4\n            rounded-full\n            border-[2px]\n            border-solid\n            border-line\n            bg-transparent\n            hover:border-primary\n            peer-disabled:hover:border-line\n            peer-hover:border-primary\n            peer-disabled:peer-hover:border-line\n            peer-checked:border-primary\n            peer-disabled:peer-checked:border-line\n            peer-checked:after:content-['']\n            peer-checked:after:rounded-full\n            peer-checked:after:w-[10px]\n            peer-checked:after:h-[10px]\n            peer-checked:after:min-w-[10px]\n            peer-checked:after:min-h-[10px]\n            peer-checked:after:absolute\n            peer-checked:after:top-[50%]\n            peer-checked:after:left-[50%]\n            peer-checked:after:translate-x-[-50%]\n            peer-checked:after:translate-y-[-50%]\n            peer-checked:after:block\n            peer-checked:after:bg-primary\n            peer-disabled:border-line\n            peer-checked:peer-disabled:after:bg-line\n            disabled:border-line\n          "
    }
  ), radioType === "tick" && /* @__PURE__ */ React45.createElement(
    "span",
    {
      className: "\n            content-['']\n            block\n            relative\n            top-0\n            left-0\n            w-4\n            h-4\n            min-w-4\n            min-h-4\n            rounded-full\n            border-[2px]\n            border-solid\n            border-line\n            hover:border-primary\n            peer-disabledhover:border-line\n            peer-hover:border-primary\n            peer-disabled:peer-hover:border-line\n            peer-checked:border-primary\n            peer-disabled:peer-checked:border-line\n            peer-checked:bg-primary\n            peer-disabled:peer-checked:bg-line\n            peer-checked:after:content-['']\n            peer-checked:after:w-[4px]\n            peer-checked:after:h-[7px]\n            peer-checked:after:min-w-[4px]\n            peer-checked:after:min-h-[7px]\n            peer-checked:after:absolute\n            peer-checked:after:top-[65%]\n            peer-checked:after:left-[50%]\n            peer-checked:after:translate-x-[-50%]\n            peer-checked:after:translate-y-[-85%]\n            peer-checked:after:rotate-45\n            peer-checked:after:border-solid\n            peer-checked:after:border-t-0\n            peer-checked:after:border-r-[2px]\n            peer-checked:after:border-b-[2px]\n            peer-checked:after:border-l-0\n            peer-checked:after:border-white\n            peer-disabled:peer-checked:after:bg-line\n            peer-disabled:border-line\n            disabled:border-line\n          "
    }
  )), label && /* @__PURE__ */ React45.createElement("label", { htmlFor: name, className: "capitalize peer-disabled:bg-[#9ca3af]" }, label));
}
var Radio_default = Radio;

// src/common/RadioGroup/index.tsx
function RadioGroup({
  dataTestId,
  className,
  value,
  field,
  options,
  isDisabled = false,
  orientation = "horizontal",
  radioType = "circle",
  onChange
}) {
  return /* @__PURE__ */ React46.createElement(
    "div",
    {
      className: clsx30(
        "flex flex-wrap",
        {
          "items-center": orientation === "horizontal",
          "flex-col items-start": orientation === "vertical"
        },
        className
      ),
      "data-testid": dataTestId
    },
    options.map((option) => /* @__PURE__ */ React46.createElement(
      Radio_default,
      {
        key: option.name,
        label: option.label,
        id: option.name,
        name: field,
        onChange,
        value: option.value,
        selected: value === option.value,
        disabled: isDisabled,
        radioType
      }
    ))
  );
}
var RadioGroup_default = RadioGroup;

// src/common/Modal/index.tsx
import clsx31 from "clsx";
import React47, { useEffect as useEffect9 } from "react";
import { CloseIcon as CloseIcon2 } from "@alphafounders/icons";
function Modal({
  isOpen,
  onClose,
  title,
  hasCloseButton = true,
  children,
  size = "medium",
  dataTestId = "common-modal-component"
}) {
  const handleOnClick = () => {
    if (hasCloseButton) {
      onClose();
    }
  };
  useEffect9(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isOpen]);
  if (!isOpen) return null;
  return /* @__PURE__ */ React47.createElement(
    "dialog",
    {
      open: isOpen,
      className: "w-full h-full bg-transparent/30 backdrop-blur-sm border-0 backdrop-grayscale-0 m-0 p-0 fixed z-[1300] inset-0",
      "data-testid": dataTestId
    },
    /* @__PURE__ */ React47.createElement("div", { className: "fixed inset-0 z-10 overflow-y-auto" }, /* @__PURE__ */ React47.createElement("div", { className: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }, /* @__PURE__ */ React47.createElement(
      "div",
      {
        className: clsx31(
          "relative transform rounded-lg p-5 text-left transition-all",
          {
            "max-w-sm w-sm": size === "small",
            "max-w-lg w-lg": size === "medium",
            "max-w-full w-full": size === "large"
          }
        )
      },
      /* @__PURE__ */ React47.createElement("div", { className: "header-section overflow-y-auto rounded-t-lg" }, hasCloseButton && /* @__PURE__ */ React47.createElement(
        "span",
        {
          className: "absolute top-0 right-0 w-[36px] h-[36px] rounded-full z-30 bg-white cursor-pointer flex items-center justify-center",
          onClick: handleOnClick
        },
        /* @__PURE__ */ React47.createElement(CloseIcon2, { className: "w-4 h-4" })
      ), title && /* @__PURE__ */ React47.createElement("div", { className: "bg-primary text-white min-h-[50px] flex justify-center items-center font-bold text-lg" }, title)),
      /* @__PURE__ */ React47.createElement(
        "div",
        {
          className: clsx31("p-[30px] bg-white rounded-b-lg shadow-xl", {
            "rounded-t-lg": !title
          })
        },
        children
      )
    )))
  );
}
var Modal_default = Modal;

// src/common/LabelWithIcon/index.tsx
import clsx32 from "clsx";
import React48 from "react";
function LabelWithIcon({
  name,
  value,
  placeholder,
  icon,
  onClick,
  className
}) {
  return /* @__PURE__ */ React48.createElement(
    "div",
    {
      "data-testid": `${name}-labelWithIcon`,
      onClick,
      role: "button",
      onKeyDown: onClick,
      tabIndex: 0,
      className: clsx32("flex justify-between items-center p-[10px]", className)
    },
    value,
    placeholder && !value && /* @__PURE__ */ React48.createElement("span", { className: "text-gray-400 cursor-pointer" }, placeholder),
    icon && /* @__PURE__ */ React48.createElement("span", { className: "flex items-center cursor-pointer" }, icon)
  );
}
var LabelWithIcon_default = LabelWithIcon;

// src/SmoothMount.tsx
import React49, { useEffect as useEffect10, useState as useState7 } from "react";
function SmoothMount({ children }) {
  const [maxHeight, setMaxHeight] = useState7(0);
  useEffect10(() => {
    setTimeout(() => setMaxHeight(1e4), 5);
  }, []);
  return /* @__PURE__ */ React49.createElement(
    "div",
    {
      className: "overflow-hidden",
      style: { maxHeight, transition: "max-height 5s" }
    },
    children
  );
}
var SmoothMount_default = SmoothMount;

// src/FileDrop/index.tsx
import clsx33 from "clsx";
import React51, { useEffect as useEffect11, useState as useState8 } from "react";
import { useDropzone } from "react-dropzone";
import { FileCopyIcon, TrashBinIcon } from "@alphafounders/icons";

// src/FileDrop/DefaultSelectFileBody.tsx
import React50 from "react";
function DefaultSelectFileBody({ fileName }) {
  const { t } = useUIContext_default();
  if (fileName) {
    return /* @__PURE__ */ React50.createElement("span", null, fileName);
  }
  return /* @__PURE__ */ React50.createElement("span", null, t("dragAndDropFile"), " ", /* @__PURE__ */ React50.createElement("span", { className: "text-primary" }, t("chooseFile")));
}
var DefaultSelectFileBody_default = DefaultSelectFileBody;

// src/FileDrop/helper.ts
var decodeFileDropErrors = (errors) => {
  const errorMessages = errors.reduce(
    (p, v) => p.concat(v.errors.map((x) => x.message)),
    []
  );
  return errorMessages.join("\n");
};

// src/FileDrop/index.tsx
function FileDrop({
  headIcon,
  selectFileBody,
  disabled,
  accept,
  className,
  error,
  onFileDrop,
  onFileRemove,
  files,
  maxFiles = 1
}) {
  const [_files, setFiles] = useState8([]);
  const handleFileDrop = async (dropFiles) => {
    if (dropFiles.length) {
      try {
        await onFileDrop(dropFiles);
        if (files === void 0) {
          setFiles(dropFiles);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };
  const handleFileRemove = async () => {
    try {
      await onFileRemove?.();
      if (files === void 0) {
        setFiles([]);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const {
    getRootProps,
    getInputProps,
    open: openFileBrowser,
    fileRejections
  } = useDropzone({
    onDrop: handleFileDrop,
    disabled,
    accept,
    maxFiles
  });
  useEffect11(() => {
    if (files) {
      setFiles(files);
    }
  }, [files]);
  return /* @__PURE__ */ React51.createElement(
    "div",
    {
      className: clsx33("p-3 rounded-xl border border-solid border-muted-light")
    },
    /* @__PURE__ */ React51.createElement("div", { className: "flex justify-between items-center" }, /* @__PURE__ */ React51.createElement(
      "div",
      {
        className: clsx33("flex grow items-center", className),
        "data-testid": "drop-zone",
        ...getRootProps()
      },
      /* @__PURE__ */ React51.createElement("div", null, headIcon && _files.length === 0 && /* @__PURE__ */ React51.createElement(
        Button_default,
        {
          className: "p-1 bg-white border-0",
          onClick: openFileBrowser,
          text: headIcon
        }
      ), _files.length > 0 && /* @__PURE__ */ React51.createElement("div", { className: "flex items-center justify-center mx-2 text-primary bg-muted-light w-7 h-7 rounded-full" }, /* @__PURE__ */ React51.createElement(FileCopyIcon, null))),
      /* @__PURE__ */ React51.createElement("div", { className: "w-full text-left" }, /* @__PURE__ */ React51.createElement(
        "input",
        {
          "data-testid": "drop-zone-input",
          ...getInputProps()
        }
      ), selectFileBody ?? /* @__PURE__ */ React51.createElement(DefaultSelectFileBody_default, { fileName: _files[0]?.name }))
    ), _files.length > 0 && /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(
      Button_default,
      {
        dataTestId: "remove-file-btn",
        variant: "secondary",
        text: /* @__PURE__ */ React51.createElement(TrashBinIcon, null),
        rounded: true,
        className: "border-0 p-1",
        onClick: handleFileRemove
      }
    ))),
    /* @__PURE__ */ React51.createElement(
      "div",
      {
        "data-testid": "drop-zone-errors",
        className: "text-warning w-full whitespace-pre-wrap text-left text-[.7rem]"
      },
      decodeFileDropErrors(fileRejections) || error
    )
  );
}
var FileDrop_default = FileDrop;

// src/Table/DisplayTable.tsx
import clsx36 from "clsx";
import React55, { useMemo as useMemo4 } from "react";

// src/Table/Header.tsx
import React52 from "react";
import { twMerge as twMerge7 } from "tailwind-merge";
function Header2({ text, width, className }) {
  return /* @__PURE__ */ React52.createElement(
    "div",
    {
      className: twMerge7(
        "bg-primary text-white grow p-3 first:rounded-tl-lg last:rounded-tr-lg",
        className
      ),
      style: { width },
      "data-testid": "display-table-header"
    },
    text
  );
}
var Header_default2 = Header2;

// src/Table/Row.tsx
var import_get = __toESM(require_get());
import clsx35 from "clsx";
import React54 from "react";

// src/Table/Cell.tsx
import clsx34 from "clsx";
import React53 from "react";
import { twMerge as twMerge8 } from "tailwind-merge";
function Cell({
  content,
  width,
  selectionType,
  isSelected,
  className
}) {
  return /* @__PURE__ */ React53.createElement(
    "div",
    {
      className: twMerge8(
        clsx34("h-4 grow p-3 flex items-center", {
          "bg-gray-100": !isSelected,
          "bg-green-100": isSelected
        }),
        className
      ),
      style: { width },
      "data-testid": "display-table-cell"
    },
    selectionType !== "none" && /* @__PURE__ */ React53.createElement(
      "input",
      {
        className: "min-w-[20px] min-h-[20px]",
        type: selectionType,
        checked: isSelected
      }
    ),
    content
  );
}
var Cell_default = Cell;

// src/Table/Row.tsx
import { twMerge as twMerge9 } from "tailwind-merge";
function Row({
  gap,
  tableConfig,
  data,
  isSelected,
  onClick,
  selectionType = "none",
  className
}) {
  const getWidth = (config) => {
    const dynamicData = data;
    if (dynamicData[config.key]?.width)
      return dynamicData[config.key]?.width;
    return config.width;
  };
  return /* @__PURE__ */ React54.createElement(
    "div",
    {
      className: `flex cursor-pointer ${gap}`,
      onClickCapture: () => onClick(data),
      "data-testid": "display-table-row"
    },
    tableConfig.map((config, i) => /* @__PURE__ */ React54.createElement(
      Cell_default,
      {
        key: config.key,
        content: config.render ? config.render(data) : (0, import_get.default)(data, config.dataIndex ?? "", null),
        width: getWidth(config),
        selectionType: i === 0 ? selectionType : "none",
        className: twMerge9(
          clsx35({
            "border-solid border-0 border-l-2 border-success": i === 0 && isSelected
          }),
          className
        ),
        isSelected
      }
    ))
  );
}
var Row_default = Row;

// src/Table/DisplayTable.tsx
var GapType = /* @__PURE__ */ ((GapType2) => {
  GapType2["small"] = "small";
  GapType2["medium"] = "1";
  GapType2["big"] = "big";
  return GapType2;
})(GapType || {});
function DisplayTable({
  gap,
  data,
  tableConfig,
  selectedDataKey,
  onSelect,
  loading,
  selectionType = "none",
  noHeader
}) {
  const isSelected = (key) => {
    if (typeof selectedDataKey === "string") {
      return key === selectedDataKey;
    }
    return selectedDataKey.includes(key);
  };
  const gapTransform = useMemo4(() => {
    if (!gap) return "";
    if (gap === "big" /* big */) return "gap-2";
    if (gap === "small" /* small */) return "gap-0.5";
    return "gap-1";
  }, [gap]);
  const getTableConfigFilter = (x) => {
    const tableConfigFilter = [];
    if (x.colspan !== void 0 && x.colspan.length > 1) {
      tableConfig.forEach((config) => {
        if (x.colspan?.includes(config.key) && config.key !== x.colspan[0]) {
          return;
        }
        tableConfigFilter.push(config);
      });
      return tableConfigFilter;
    }
    return tableConfig;
  };
  return /* @__PURE__ */ React55.createElement("div", { className: clsx36("w-full") }, /* @__PURE__ */ React55.createElement("div", { className: `flex w-full ${gapTransform}` }, !noHeader && tableConfig.map((config) => /* @__PURE__ */ React55.createElement(
    Header_default2,
    {
      key: config.key,
      text: config.title,
      width: config.width,
      className: config.className
    }
  ))), loading ? /* @__PURE__ */ React55.createElement(
    "div",
    {
      role: "status",
      className: "animate-pulse w-full",
      "data-testid": "table-loading"
    },
    /* @__PURE__ */ React55.createElement("div", { className: "h-5 w-full bg-muted-light rounded my-2" }),
    /* @__PURE__ */ React55.createElement("div", { className: "h-5 w-full bg-muted-light rounded my-2" }),
    /* @__PURE__ */ React55.createElement("div", { className: "h-5 w-full bg-muted-light rounded my-2" })
  ) : /* @__PURE__ */ React55.createElement("div", { className: `flex flex-col ${gapTransform}` }, data.map((x) => /* @__PURE__ */ React55.createElement(
    Row_default,
    {
      key: x.key,
      tableConfig: getTableConfigFilter(x),
      data: x,
      gap: gapTransform,
      selectionType,
      className: x.className,
      isSelected: isSelected(x.key),
      onClick: onSelect
    }
  ))));
}
var DisplayTable_default = DisplayTable;

// src/FileDropList/index.tsx
import React56, { useState as useState9, useEffect as useEffect12 } from "react";
import { AddCircleIcon } from "@alphafounders/icons";
function FileDropList({
  maxFileDrop,
  handleFileChange,
  error
}) {
  const [files, setFiles] = useState9({});
  useEffect12(() => {
    if (files) {
      handleFileChange(files);
    }
  }, [files]);
  function handleFileRemove(name) {
    const newFiles = { ...files };
    delete newFiles[name];
    setFiles(newFiles);
  }
  const displayAddFileDrop = Object.keys(files).length < maxFileDrop;
  return /* @__PURE__ */ React56.createElement(React56.Fragment, null, /* @__PURE__ */ React56.createElement("div", { "data-testid": "prepopulated-one" }, Object.entries(files).map(([key, value]) => /* @__PURE__ */ React56.createElement(
    FileDrop_default,
    {
      key,
      className: "p-2",
      headIcon: /* @__PURE__ */ React56.createElement(AddCircleIcon, { className: "text-primary" }),
      onFileDrop: () => void 0,
      files: [value],
      onFileRemove: () => handleFileRemove(key)
    }
  ))), /* @__PURE__ */ React56.createElement("div", { "data-testid": "new-one" }, displayAddFileDrop && /* @__PURE__ */ React56.createElement(
    FileDrop_default,
    {
      className: "p-2",
      files: [],
      headIcon: /* @__PURE__ */ React56.createElement(AddCircleIcon, { className: "text-primary" }),
      onFileDrop: (filesData) => {
        setFiles({
          ...files,
          [filesData[0].name]: filesData[0]
        });
      },
      onFileRemove: () => void 0,
      error
    }
  )));
}
var FileDropList_default = FileDropList;

// src/common/Autocomplete/index.tsx
import * as React58 from "react";
import { useCombobox, useMultipleSelection } from "downshift";
import { useEffect as useEffect14, useMemo as useMemo5, useState as useState11 } from "react";
import clsx38 from "clsx";
import { ArrowDownIcon as ArrowDownIcon2, CloseIcon as CloseIcon4 } from "@alphafounders/icons";

// src/common/Autocomplete/OptionItems.tsx
import React57, { useEffect as useEffect13, useState as useState10 } from "react";
import { CloseIcon as CloseIcon3 } from "@alphafounders/icons";
import clsx37 from "clsx";
function OptionItems({
  selectedItems,
  limitTag,
  titleLimit,
  removeSelectedItem,
  isOpen,
  getToggleButtonProps
}) {
  const [items, setItems] = useState10(selectedItems);
  const shouldLimit = !isOpen && limitTag && selectedItems?.length > 2;
  useEffect13(() => {
    if (shouldLimit) {
      setItems(selectedItems.slice(0, 2));
      return;
    }
    setItems(selectedItems);
  }, [shouldLimit, selectedItems]);
  const listItems = items.map((selectedItemForRender, index) => {
    const { title, icon } = selectedItemForRender;
    return /* @__PURE__ */ React57.createElement(
      "div",
      {
        className: "flex relative items-center bg-primary text-white rounded-md py-1 px-2 [&_path]:fill-white [&_svg]:fill-white",
        key: `selected-item-${index}`,
        "data-testid": "selected-item"
      },
      icon && /* @__PURE__ */ React57.createElement("span", { className: "mr-2 absolute top-0.5" }, icon),
      /* @__PURE__ */ React57.createElement("span", { className: clsx37(icon && "pl-[23px]") }, titleLimit ? title.substring(0, titleLimit) : title),
      /* @__PURE__ */ React57.createElement(
        "button",
        {
          className: "cursor-pointer",
          onClick: () => {
            removeSelectedItem(selectedItemForRender);
          },
          "data-testid": "remove-selected-item"
        },
        /* @__PURE__ */ React57.createElement(CloseIcon3, { className: "ml-2.5 w-2.5 h-2.5", fillColor: "#ffffff" })
      )
    );
  });
  return /* @__PURE__ */ React57.createElement(React57.Fragment, null, listItems, shouldLimit && /* @__PURE__ */ React57.createElement("span", { className: "bg-disabled text-body rounded-md py-1 px-2" }, /* @__PURE__ */ React57.createElement("span", { className: "px-1 cursor-pointer", ...getToggleButtonProps() }, "+", selectedItems.length - 2, " more", /* @__PURE__ */ React57.createElement(CloseIcon3, { className: "ml-2.5 w-2.5 h-2.5", fillColor: "#4f4b66" }))));
}
var OptionItems_default = OptionItems;

// src/common/Autocomplete/index.tsx
function getFilteredOptions(options, selectedItems, inputValue) {
  const lowerCasedInputValue = inputValue.toLowerCase();
  return options.filter((option) => {
    return !selectedItems.find((item) => option.title === item.title) && option.title.toLowerCase().includes(lowerCasedInputValue);
  });
}
function Autocomplete({
  optionType = "default",
  options,
  label,
  limitTag = true,
  titleLimit,
  showClearButton = true,
  onChange
}) {
  const [inputValue, setInputValue] = useState11("");
  const [selectedItems, setSelectedItems] = useState11([]);
  const items = useMemo5(() => {
    if (optionType === "checkbox") return options;
    return getFilteredOptions(options, selectedItems, inputValue);
  }, [optionType, options, selectedItems, inputValue]);
  const { getDropdownProps, removeSelectedItem, reset } = useMultipleSelection({
    selectedItems,
    onStateChange({ selectedItems: newSelectedItems, type }) {
      switch (type) {
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
        case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
        case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
          setSelectedItems(newSelectedItems ?? []);
          break;
        case useMultipleSelection.stateChangeTypes.FunctionReset:
          setSelectedItems([]);
          break;
        default:
          break;
      }
    }
  });
  const {
    isOpen,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    highlightedIndex,
    getItemProps,
    selectedItem
  } = useCombobox({
    items,
    itemToString(item) {
      return item ? item.title : "";
    },
    defaultHighlightedIndex: 0,
    // after selection, highlight the first item.
    selectedItem: null,
    inputValue,
    stateReducer(_state, actionAndChanges) {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: true,
            // keep the menu open after selection.
            highlightedIndex: 0
            // with the first option highlighted.
          };
        default:
          return changes;
      }
    },
    onStateChange({
      inputValue: newInputValue,
      type,
      selectedItem: newSelectedItem
    }) {
      if (optionType === "checkbox") return;
      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputBlur:
          if (newSelectedItem) {
            setSelectedItems([...selectedItems, newSelectedItem]);
            setInputValue("");
          }
          break;
        case useCombobox.stateChangeTypes.InputChange:
          setInputValue(newInputValue ?? "");
          break;
        default:
          break;
      }
    },
    onSelectedItemChange: ({ selectedItem: selectedItem2 }) => {
      if (!selectedItem2) return;
      const itemExists = selectedItems.find(
        (item) => item.value === selectedItem2.value
      );
      if (itemExists) {
        setSelectedItems(
          (prevItems) => prevItems.filter((item) => item.value !== selectedItem2.value)
        );
      } else {
        setSelectedItems([...selectedItems, selectedItem2]);
      }
    }
  });
  useEffect14(() => {
    onChange(selectedItems);
  }, [selectedItems]);
  const transparentBtnClass = "border-0 bg-transparent outline-0 text-primary cursor-pointer";
  return /* @__PURE__ */ React58.createElement("div", { className: "w-full font-body" }, label && /* @__PURE__ */ React58.createElement("label", { className: "w-fit", ...getLabelProps() }, label), /* @__PURE__ */ React58.createElement("div", { className: "flex min-h-[47px] flex-col gap-1 border border-solid border-primary rounded-[10px] shadow-sm bg-white" }, /* @__PURE__ */ React58.createElement("div", { className: "inline-flex min-h-[31px] relative gap-2 items-center flex-wrap p-2 px-4 text-sm pr-16" }, /* @__PURE__ */ React58.createElement(
    OptionItems_default,
    {
      ...{
        selectedItems,
        limitTag,
        titleLimit,
        removeSelectedItem,
        isOpen,
        getToggleButtonProps
      }
    }
  ), /* @__PURE__ */ React58.createElement(
    "input",
    {
      className: "w-0 min-w-[30px] border-0 outline-0 grow",
      ...getInputProps(getDropdownProps({ preventKeyAction: isOpen }))
    }
  ), /* @__PURE__ */ React58.createElement("div", { className: "flex absolute top-2.5 right-0" }, showClearButton && selectedItems.length > 0 && /* @__PURE__ */ React58.createElement(
    "button",
    {
      className: transparentBtnClass,
      type: "button",
      onClick: reset
    },
    /* @__PURE__ */ React58.createElement(CloseIcon4, { className: "m-0" })
  ), /* @__PURE__ */ React58.createElement(
    "button",
    {
      "aria-label": "toggle menu",
      className: transparentBtnClass,
      type: "button",
      ...getToggleButtonProps()
    },
    /* @__PURE__ */ React58.createElement(
      ArrowDownIcon2,
      {
        className: clsx38(isOpen && "rotate-180", "w-6 h-6 ml-0")
      }
    )
  ))), /* @__PURE__ */ React58.createElement(
    "ul",
    {
      className: `w-inherit bg-transparent mt-1 mb-0 max-h-80 overflow-y-auto overflow-x-none p-0 scroll-smooth text-body ${!(isOpen && items.length) && "hidden"}`,
      ...getMenuProps()
    },
    isOpen && items.map((item, index) => /* @__PURE__ */ React58.createElement(
      "li",
      {
        className: clsx38(
          highlightedIndex === index && "bg-disabled",
          selectedItem === item && "font-bold",
          "py-2 px-3 flex flex-col"
        ),
        key: `${item.value}${index}`,
        ...getItemProps({
          item,
          index,
          "aria-selected": selectedItems.includes(item)
        })
      },
      /* @__PURE__ */ React58.createElement("div", { className: "flex justify-between items-center" }, /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement("span", { className: "mr-1" }, item?.icon && item.icon), /* @__PURE__ */ React58.createElement("span", null, item.title)), optionType === "checkbox" && /* @__PURE__ */ React58.createElement(
        Checkbox_default,
        {
          onChange: () => null,
          value: item?.value,
          checked: selectedItems.includes(item)
        }
      ))
    ))
  )));
}
var Autocomplete_default = Autocomplete;

// src/common/ProgresBar/index.tsx
import React59 from "react";

// src/utils/progressBar.ts
function getSafePercent(percent) {
  if (percent > 100 || percent < 0 || typeof percent !== "number") {
    console.warn(
      `[progress-bar]: The value passed to percent or position needs to be a number between 0 and 100 (passed value: ${percent}).`
    );
  }
  return Math.min(100, Math.max(percent, 0));
}
function getStepPosition(steps, stepIndex, hasStepZero) {
  if (hasStepZero) {
    return 100 / (steps - 1) * stepIndex;
  }
  return 100 / steps * (stepIndex + 1);
}
var transitions = {
  scale: {
    entering: { transform: "translateX(-50%) scale(1.5)" },
    entered: { transform: "translateX(-50%) scale(1)" },
    exiting: { transform: "translateX(-50%) scale(1.5)" },
    exited: { transform: "translateX(-50%) scale(1)" }
  },
  rotate: {
    entering: { transform: "translateX(-50%) rotate(360deg)" },
    entered: { transform: "translateX(-50%) rotate(0deg)" },
    exiting: { transform: "translateX(-50%) rotate(0deg)" },
    exited: { transform: "translateX(-50%) rotate(360deg)" }
  },
  skew: {
    entering: { transform: "translateX(-50%) skewX(20deg)" },
    entered: { transform: "translateX(-50%) skewX(0deg)" },
    exiting: { transform: "translateX(-50%) skewX(20deg)" },
    exited: { transform: "translateX(-50%) skewX(0deg)" }
  }
};

// src/common/ProgresBar/index.tsx
import clsx39 from "clsx";
function ProgressBar2({
  percent,
  stepPositions = [],
  unfilledBackground = "",
  filledBackground = "",
  width,
  height,
  hasStepZero = true,
  text,
  progressionClasses,
  progressBarClasses,
  children
}) {
  if (stepPositions && stepPositions.length > 0 && stepPositions.length !== React59.Children.count(children)) {
    throw new Error(
      "When specifying a stepPositions prop, the number of children must match the length of the positions array."
    );
  }
  const safePercent = getSafePercent(percent);
  const renderChildren = () => {
    return React59.Children.map(children, (step, index) => {
      const position = stepPositions?.length > 0 ? stepPositions[index] : getStepPosition(React59.Children.count(children), index, hasStepZero);
      return step ? React59.cloneElement(step, {
        accomplished: position <= safePercent,
        position,
        index
      }) : null;
    });
  };
  return /* @__PURE__ */ React59.createElement(
    "div",
    {
      "data-testid": "progress-bar",
      className: clsx39(
        "h-2.5 leading-none relative bg-gray-300 flex justify-between items-center z-0 rounded-10",
        progressBarClasses
      ),
      style: { background: unfilledBackground, width, height }
    },
    renderChildren(),
    text && /* @__PURE__ */ React59.createElement("div", { className: "text-white text-[10px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" }, text),
    /* @__PURE__ */ React59.createElement(
      "div",
      {
        className: clsx39(
          "absolute transition-all duration-300 ease-in-out inset-0 rounded-10 z-[-1]",
          progressionClasses
        ),
        style: {
          width: `${safePercent}%`,
          backgroundColor: filledBackground
        }
      }
    )
  );
}
var ProgresBar_default = ProgressBar2;

// src/common/ProgresBar/Step.tsx
import React60 from "react";
import { Transition } from "react-transition-group";
function Step({
  accomplished = false,
  position = 0,
  index = 0,
  children,
  transition = "scale",
  transitionDuration = 300
}) {
  const safePosition = getSafePercent(position);
  return /* @__PURE__ */ React60.createElement(Transition, { in: accomplished, timeout: transitionDuration }, (state) => {
    const style = {
      left: `${safePosition}%`,
      transitionDuration: `${transitionDuration}ms`,
      ...transition ? transitions[transition][state] : {}
    };
    return /* @__PURE__ */ React60.createElement(
      "div",
      {
        "data-testid": "step",
        className: "inline-flex justify-center items-center z-0 absolute transform -translate-x-1/2 transition-all ease-linear",
        style
      },
      children({
        accomplished,
        position: safePosition,
        transitionState: state,
        index
      })
    );
  });
}
var Step_default = Step;

// src/common/Buttons/UpButton.tsx
import React61, { useState as useState12, useEffect as useEffect15 } from "react";
import clsx40 from "clsx";
import { ArrowDownIcon as ArrowDownIcon3 } from "@alphafounders/icons";
function UpButton({
  questionOrder,
  buttonLabel,
  screenSize,
  icon
}) {
  const [show, setShow] = useState12(false);
  const updateDisplay = () => {
    setShow(window?.scrollY > 200 && window?.innerWidth <= screenSize?.SMALL);
  };
  const offset = (el) => {
    const rect = el?.getBoundingClientRect();
    const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect?.left + scrollLeft };
  };
  const scrollUp = (e) => {
    e.preventDefault();
    const userCurrentPosition = window.scrollY;
    const progressBarSize = 65;
    const upperQuestion = questionOrder.reduce(
      (previous, qn) => offset(document.getElementById(qn)).top < userCurrentPosition ? qn : previous,
      ""
    );
    const upperQnBlock = document.getElementById(upperQuestion);
    window.scrollTo({
      top: offset(upperQnBlock).top - progressBarSize,
      behavior: "smooth"
    });
  };
  useEffect15(() => {
    window.addEventListener("resize", updateDisplay);
    window.addEventListener("scroll", updateDisplay);
    return () => {
      window.removeEventListener("resize", updateDisplay);
      window.removeEventListener("scroll", updateDisplay);
    };
  }, []);
  return /* @__PURE__ */ React61.createElement(
    "button",
    {
      className: clsx40(
        "fixed top-[5.125rem] right-[1.25rem] z-30",
        show && "visible md:hidden",
        !show && "invisible"
      ),
      onClick: scrollUp,
      type: "button",
      "data-testid": "up-button"
    },
    /* @__PURE__ */ React61.createElement(
      "div",
      {
        className: clsx40(
          "bg-borderColor rounded-full w-[40px] h-[40px] py-[3px] px-[11px] text-sm",
          "flex flex-col items-center justify-center"
        )
      },
      icon || /* @__PURE__ */ React61.createElement(ArrowDownIcon3, { className: "text-[#005098] w-[40px] h-[40px] rotate-180 ml-0" }),
      /* @__PURE__ */ React61.createElement("div", { className: "text-[#005098]" }, buttonLabel)
    )
  );
}
var UpButton_default = UpButton;

// src/common/Accordion/index.tsx
import React64, { useState as useState13 } from "react";
import clsx42 from "clsx";
import { ArrowDownIcon as ArrowDownIcon4 } from "@alphafounders/icons";

// src/common/MarkDown.tsx
import React62 from "react";
import showdown from "showdown";
import clsx41 from "clsx";
function Markdown({ md, cssClass }) {
  const converter = new showdown.Converter({
    strikethrough: true,
    splitAdjacentBlockquotes: true,
    simpleLineBreaks: true
  });
  return /* @__PURE__ */ React62.createElement(
    "div",
    {
      className: clsx41(cssClass),
      dangerouslySetInnerHTML: { __html: converter.makeHtml(md) }
    }
  );
}
var MarkDown_default = Markdown;

// src/common/Accordion/TextPanel.tsx
import React63 from "react";
function TextPanel({ textDetails, code }) {
  const renderMarkDown = (content, key) => /* @__PURE__ */ React63.createElement("div", { key: `text-panel-${key + 1}`, className: "flex pb-1" }, /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: "flex-1 text-left  px-[7px] -mt-[2px]",
      "data-testid": `${code}-text-${key + 1}`
    },
    /* @__PURE__ */ React63.createElement(
      MarkDown_default,
      {
        md: content,
        cssClass: "text-[12px] leading-[19px] text-left custom-markdown"
      }
    )
  ));
  return /* @__PURE__ */ React63.createElement("div", { className: "rounded-[10px] overflow-hidden text-left p-[10px]" }, typeof textDetails === "string" && renderMarkDown(textDetails, 0), typeof textDetails === "object" && textDetails.length > 0 && textDetails.map(
    (item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React63.createElement("div", { key: `${index}-label` }, /* @__PURE__ */ React63.createElement("span", { className: "text-sm font-bold pb-[4px]" }, item?.label), renderMarkDown(item?.values, index))
    )
  ));
}

// src/common/Accordion/index.tsx
function AccordionSection({
  items,
  defaultIndex = [],
  cardType = "accordion",
  sectionIndex = 0
}) {
  const isAccordion = cardType === "accordion";
  const [openItems, setOpenItems] = useState13(defaultIndex);
  const isOpenItem = (index) => openItems?.some((idx) => idx === index);
  const onOpenItem = (index) => {
    if (isOpenItem(index)) {
      setOpenItems((prev) => prev.filter((idx) => idx !== index));
    } else {
      setOpenItems((prev) => [...prev, index]);
    }
  };
  return /* @__PURE__ */ React64.createElement("div", { "data-testid": `accordion-section-${sectionIndex}` }, items.map((item, index) => /* @__PURE__ */ React64.createElement(
    "div",
    {
      key: item.code,
      className: clsx42(
        "border-b border-dashed border-[#E9EDF5] border-y-0",
        index === 0 && "border-t"
      )
    },
    /* @__PURE__ */ React64.createElement(
      "div",
      {
        "data-testid": `${item.code}-title-${sectionIndex}`,
        className: clsx42(
          "py-[10px] flex items-center",
          isAccordion && "cursor-pointer hover:bg-accordionHover"
        ),
        ...isAccordion && { onClick: () => onOpenItem(index) }
      },
      /* @__PURE__ */ React64.createElement("div", { className: "pl-[16px] text-textColor flex-1 text-left" }, /* @__PURE__ */ React64.createElement("span", { className: "text-sm font-bold" }, item.titleText)),
      isAccordion && /* @__PURE__ */ React64.createElement(
        ArrowDownIcon4,
        {
          className: clsx42(
            "fill-rabbitBlue mr-[22px]",
            "transition-all ease-in-out duration-300",
            isOpenItem(index) ? "rotate-180" : "rotate-0"
          )
        }
      )
    ),
    /* @__PURE__ */ React64.createElement(
      "div",
      {
        "data-testid": "accordion-panel",
        className: clsx42(
          "transition-all ease-in-out overflow-hidden",
          isOpenItem(index) ? "max-h-screen pb-[10px] duration-500" : "max-h-0 duration-300"
        )
      },
      item.type && item.type === "text" && /* @__PURE__ */ React64.createElement(TextPanel, { textDetails: item.textDetails, code: item?.code })
    )
  )));
}
var Accordion_default = AccordionSection;

// src/Voucher/Card.tsx
import React65 from "react";
function VoucherCard({
  title,
  subTitle,
  logo,
  description,
  dataTestId,
  eligiblePeriod,
  items,
  btnLabel,
  onClick
}) {
  return /* @__PURE__ */ React65.createElement(
    "div",
    {
      className: "bg-white my-[16px] rounded-lg border-[1px] border-solid border-[#E9EDF5] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
      "data-testid": dataTestId
    },
    /* @__PURE__ */ React65.createElement("div", { className: "row-span-2 pl-[16px] pt-[16px] md:pb-[10px]" }, logo),
    /* @__PURE__ */ React65.createElement("div", { className: "lg:col-span-3 col-span-2 pr-[16px] pt-[16px] pl-[8px]" }, /* @__PURE__ */ React65.createElement("span", { className: "my-2 mx-0 font-[400] text-[16px] md:text-[20px]" }, title), /* @__PURE__ */ React65.createElement("span", { className: "my-2 md:my-0 mx-0 text-[20px] font-[600] block" }, subTitle), eligiblePeriod && /* @__PURE__ */ React65.createElement("span", { className: "text-[#757575] my-2 mx-0 text-[12px] block" }, eligiblePeriod), description && !eligiblePeriod && /* @__PURE__ */ React65.createElement("span", { className: "text-[#757575] my-2 mx-0 text-[12px] md:block hidden" }, description)),
    /* @__PURE__ */ React65.createElement("div", { className: "md:col-span-2 lg:col-span-3 col-span-3 px-[16px] py-[8px] md:px-[8px]" }, /* @__PURE__ */ React65.createElement("span", { className: "text-[#757575] my-2 mx-0 font-[400] text-[16px] block md:hidden" }, description)),
    items.length && /* @__PURE__ */ React65.createElement("div", { className: "md:col-span-3 col-span-3 lg:col-span-4 px-0" }, /* @__PURE__ */ React65.createElement(Accordion_default, { items })),
    /* @__PURE__ */ React65.createElement(
      Button_default,
      {
        text: btnLabel,
        onClick,
        className: "w-full col-span-2 leading-[3.5rem] md:col-span-3 lg:col-span-4 p-0 mt-[5px] rounded-b-md",
        roundedNone: true
      }
    )
  );
}
var Card_default2 = VoucherCard;

// src/VoucherRedemption/RedemptionCard.tsx
import React66 from "react";
import clsx43 from "clsx";
var RedemptionCard = ({
  partnerName,
  discount,
  code,
  copyButtonText,
  className,
  onCopyCode,
  isCopied
}) => {
  return /* @__PURE__ */ React66.createElement(
    "div",
    {
      className: clsx43(
        "border border-solid border-[#757575] mx-auto bg-white rounded-lg p-4 max-w-full",
        "flex flex-col justify-center items-center gap-10",
        className
      )
    },
    /* @__PURE__ */ React66.createElement("div", { className: "text-center font-normal text-[#1E1E1E]" }, /* @__PURE__ */ React66.createElement("span", null, partnerName), /* @__PURE__ */ React66.createElement("span", { className: "mx-2" }, "-"), /* @__PURE__ */ React66.createElement("span", null, discount)),
    /* @__PURE__ */ React66.createElement("div", { className: "text-muted-darker" }, code),
    /* @__PURE__ */ React66.createElement(
      Button_default,
      {
        text: copyButtonText ?? "Copy Code",
        onClick: onCopyCode,
        className: "py-[15px] px-[16px] cursor-copy",
        disabled: isCopied
      }
    )
  );
};
var RedemptionCard_default = RedemptionCard;

// src/VoucherRedemption/VoucherSummary.tsx
import React67 from "react";
import clsx44 from "clsx";
var VoucherSummary = ({
  image,
  title,
  subtitle,
  description,
  className
}) => {
  return /* @__PURE__ */ React67.createElement(
    "div",
    {
      className: clsx44(
        "mx-auto flex flex-col justify-center items-center",
        className
      )
    },
    /* @__PURE__ */ React67.createElement("div", null, image),
    /* @__PURE__ */ React67.createElement("div", { className: "text-center" }, /* @__PURE__ */ React67.createElement(
      "div",
      {
        className: "my-[18px] font-normal text-[24px]",
        dangerouslySetInnerHTML: {
          __html: title
        }
      }
    ), /* @__PURE__ */ React67.createElement("p", null, subtitle), /* @__PURE__ */ React67.createElement("p", null, description))
  );
};
var VoucherSummary_default = VoucherSummary;

// src/ProfileInfo/index.tsx
import clsx45 from "clsx";
import React68 from "react";

// src/ProfileInfo/data.json
var data_default = [
  {
    title: "Personal information",
    isHeader: true
  },
  {
    title: "Title",
    description: "",
    key: "title"
  },
  {
    title: "First Name",
    description: "",
    key: "firstName"
  },
  {
    title: "Last Name",
    description: "",
    key: "lastName"
  },
  {
    title: "Date of Birth",
    description: "",
    key: "dateOfBirth"
  },
  {
    title: "Contact details",
    isHeader: true
  },
  {
    title: "Primary Phone Number",
    description: "",
    key: "phoneNumber"
  },
  {
    title: "Email",
    description: "",
    key: "email"
  }
];

// src/ProfileInfo/index.tsx
function ProfileInfo(profileData) {
  Object.entries(profileData).map(([key, value]) => {
    data_default.map((item) => {
      if (item.key === key) {
        item.description = value;
      }
    });
  });
  return /* @__PURE__ */ React68.createElement("div", { className: "bg-white p-4 mb-5 md:mb-8 rounded-lg shadow-custom-shadow divide-y divide-dashed" }, data_default.map((item) => {
    return /* @__PURE__ */ React68.createElement(
      "div",
      {
        className: clsx45({
          "break-words": true,
          "grid grid-cols-3 md:grid-cols-2": !item.isHeader
        }),
        key: item.title
      },
      item.isHeader ? /* @__PURE__ */ React68.createElement("h4", { className: "py-4 text-left text-primary font-bold" }, item.title) : /* @__PURE__ */ React68.createElement("div", { className: "flex items-center text-sm font-normal text-muted-darker py-2" }, item.title),
      item.description && /* @__PURE__ */ React68.createElement("div", { className: "col-span-2 md:col-span-1 grid grid-cols-3 items-center" }, /* @__PURE__ */ React68.createElement("span", { className: "col-end-1 mr-2" }, ":"), /* @__PURE__ */ React68.createElement("div", { className: "col-span-3 text-sm font-normal text-muted-darker py-2" }, item.description))
    );
  }));
}

// src/LoadingSpinner/index.tsx
import React69 from "react";
import clsx46 from "clsx";
function LoadingSpinner({
  small = false,
  dataTestId = "loading-spinner",
  loadingText = "Loading..."
}) {
  return /* @__PURE__ */ React69.createElement(
    "div",
    {
      "data-testid": dataTestId,
      className: clsx46("flex justify-center items-center", !small && "mt-6"),
      role: "status"
    },
    /* @__PURE__ */ React69.createElement("div", { className: "relative -ml-1 mr-3 h-9 w-9 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" }, /* @__PURE__ */ React69.createElement("span", { className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]" }, loadingText))
  );
}
export {
  AnchorButton_default as AnchorButton,
  Appointment_default as AppointmentModal,
  Autocomplete_default as Autocomplete,
  Badge_default as Badge,
  Button_default as Button,
  Card_default as Card,
  Checkbox_default as Checkbox,
  ClickAwayListener,
  ContactButton_default as ContactButton,
  Container_default as Container,
  CustomerPortalButton_default as CustomerPortalButton,
  DayCard_default as DayCard,
  DisclaimerSection_default as DisclaimerSection,
  DisplayTable_default as DisplayTable,
  Divider_default as Divider,
  DropdownButton_default as DropdownButton,
  FileDrop_default as FileDrop,
  FileDropList_default as FileDropList,
  FloatingButton_default as FloatingButton,
  GapType,
  HamburgerButton_default as HamburgerButton,
  Header_default as Header,
  HelpTool_default as HelpTool,
  InfoContainer_default as InfoContainer,
  InfoLeadCar_default as InfoLeadCar,
  InfoSection_default as InfoSection,
  Input_default as Input,
  Installment_default as Installment,
  LabelWithIcon_default as LabelWithIcon,
  LanguageButton_default as LanguageButton,
  LoadingSpinner,
  Modal_default as Modal,
  NotificationListTemplate_default as NotificationListTemplate,
  NotificationTemplate_default as NotificationTemplate,
  NotificationTypes,
  PhoneButton_default as PhoneButton,
  Price_default as Price,
  ProfileInfo,
  Radio_default as Radio,
  RadioGroup_default as RadioGroup,
  Rating_default as Rating,
  RedemptionCard_default as RedemptionCard,
  Select_default as Select,
  SmoothMount_default as SmoothMount,
  Step_default as Step,
  ProgresBar_default as StepProgressBar,
  Tab_default as Tab,
  Textarea_default as TextArea,
  ToggleSwitch,
  Context_default as UIContext,
  UpButton_default as UpButton,
  Card_default2 as VoucherCard,
  VoucherSummary_default as VoucherSummary,
  formatFieldResponse,
  getCarName,
  isElementInViewport,
  useScrollTo_default as useScrollTo
};
//# sourceMappingURL=index.mjs.map